import {
  ADD_BR_BUSINESS_SHARE,
  ADD_BR_BUSINESS_SHARE_FAIL,
  ADD_BR_BUSINESS_SHARE_SUCCESS,
  ADD_BR_DOMAIN_PROVIDED,
  ADD_BR_DOMAIN_PROVIDED_FAIL,
  ADD_BR_DOMAIN_PROVIDED_SUCCESS,
  ADD_BR_PORTFOLIO_ENTITY,
  ADD_BR_PORTFOLIO_ENTITY_FAIL,
  ADD_BR_PORTFOLIO_ENTITY_SUCCESS,
  ADD_BR_PORTFOLIO_REPORT_REQUEST,
  ADD_BR_PORTFOLIO_REPORT_REQUEST_FAIL,
  ADD_BR_PORTFOLIO_REPORT_REQUEST_SUCCESS,
  ADD_BR_SUBDOMAIN_PROVIDED,
  ADD_BR_SUBDOMAIN_PROVIDED_FAIL,
  ADD_BR_SUBDOMAIN_PROVIDED_SUCCESS,
  ADD_BR_TARGETIP_PROVIDED,
  ADD_BR_TARGETIP_PROVIDED_FAIL,
  ADD_BR_TARGETIP_PROVIDED_SUCCESS,
  ADD_BR_VALIDATION,
  ADD_BR_VALIDATION_FAIL,
  ADD_BR_VALIDATION_SUCCESS,
  BREACHRISK_REINIT_STATE,
  DELETE_BR_PORTFOLIO_ENTITY,
  DELETE_BR_PORTFOLIO_ENTITY_FAIL,
  DELETE_BR_PORTFOLIO_ENTITY_SUCCESS,
  FETCH_BR_BUSINESS_SHARES,
  FETCH_BR_BUSINESS_SHARES_FAIL,
  FETCH_BR_BUSINESS_SHARES_SUCCESS,
  FETCH_CYCLE_REPORT,
  FETCH_CYCLE_DETAILS,
  FETCH_CYCLE_DETAILS_FAIL,
  FETCH_CYCLE_DETAILS_SUCCESS,
  FETCH_CYCLE_REPORT_FAIL,
  FETCH_CYCLE_REPORT_SUCCESS,
  FETCH_CYCLE_TARGETS,
  FETCH_CYCLE_TARGETS_FAIL,
  FETCH_CYCLE_TARGETS_SUCCESS,
  FETCH_PORTFOLIO,
  FETCH_PORTFOLIO_FAIL,
  FETCH_PORTFOLIO_SUCCESS,
  SET_ENTITY_IN_VIEW,
  UPDATE_BR_ATTACKS_AUTHORIZED,
  UPDATE_BR_ATTACKS_AUTHORIZED_FAIL,
  UPDATE_BR_ATTACKS_AUTHORIZED_SUCCESS,
  UPDATE_BR_BUSINESS_SHARE,
  UPDATE_BR_BUSINESS_SHARE_FAIL,
  UPDATE_BR_BUSINESS_SHARE_SUCCESS,
  UPDATE_BR_DOMAIN_PROVIDED,
  UPDATE_BR_DOMAIN_PROVIDED_FAIL,
  UPDATE_BR_DOMAIN_PROVIDED_SUCCESS,
  UPDATE_BR_SUBDOMAIN_PROVIDED,
  UPDATE_BR_SUBDOMAIN_PROVIDED_FAIL,
  UPDATE_BR_SUBDOMAIN_PROVIDED_SUCCESS,
  UPDATE_BR_TARGETIP_PROVIDED,
  UPDATE_BR_TARGETIP_PROVIDED_FAIL,
  UPDATE_BR_TARGETIP_PROVIDED_SUCCESS,
  ADD_TAG_SUCCESS_TESTED_VECTORS,
  ADD_TAG_FAIL_TESTED_VECTORS,
  UPDATE_TAG_FAIL_TESTED_VECTORS,
  UPDATE_TAG_SUCCESS_TESTED_VECTORS,
  CLOUD_INTEGRATION_GET_OPTIONS,
  CLOUD_INTEGRATION_GET_OPTIONS_SUCCESS,
  CLOUD_INTEGRATION_GET_OPTIONS_FAIL,
  CLOUD_INTEGRATION_REGISTER,
  CLOUD_INTEGRATION_REGISTER_SUCCESS,
  CLOUD_INTEGRATION_REGISTER_FAIL,
  CLOUD_INTEGRATION_UNREGISTER,
  CLOUD_INTEGRATION_UNREGISTER_SUCCESS,
  CLOUD_INTEGRATION_UNREGISTER_FAIL,
  FETCH_TARGET_DETAILS,
  FETCH_TARGET_DETAILS_SUCCESS,
  FETCH_TARGET_DETAILS_FAIL,
  FETCH_CYCLE_SOCIAL,
  FETCH_CYCLE_SOCIAL_SUCCESS,
  FETCH_CYCLE_SOCIAL_FAIL,
  FETCH_IDENTITY_DETAILS_FAIL,
  FETCH_IDENTITY_DETAILS_SUCCESS,
  FETCH_IDENTITY_DETAILS,
  UPDATE_BR_SOCIAL_TESTS_AUTHORIZED,
  UPDATE_BR_SOCIAL_TESTS_AUTHORIZED_SUCCESS,
  UPDATE_BR_SOCIAL_TESTS_AUTHORIZED_FAIL,
  UPDATE_TAG_IDENTITY_FAIL,
  UPDATE_TAG_IDENTITY_SUCCESS,
  ADD_TAG_IDENTITY_FAIL,
  ADD_TAG_IDENTITY_SUCCESS,
  ADD_BR_IDENTITY_PROVIDED,
  ADD_BR_IDENTITY_PROVIDED_SUCCESS,
  ADD_BR_IDENTITY_PROVIDED_FAIL,
  UPDATE_BR_IDENTITY_PROVIDED,
  UPDATE_BR_IDENTITY_PROVIDED_SUCCESS,
  UPDATE_BR_IDENTITY_PROVIDED_FAIL,
  ADD_TAG_ENTITY_FAIL,
  UPDATE_TAG_ENTITY_SUCCESS,
  ADD_TAG_ENTITY_SUCCESS,
  UPDATE_TAG_ENTITY_FAIL,
  FETCH_CLOUD_INTEGRATION_DATA,
  FETCH_CLOUD_INTEGRATION_DATA_SUCCESS,
  FETCH_CLOUD_INTEGRATION_DATA_FAIL,
  FETCH_VECTOR_RESULTS,
  FETCH_VECTOR_RESULTS_SUCCESS,
  FETCH_VECTOR_RESULTS_FAIL,
  ADD_BR_SUBPORTFOLIO,
  ADD_BR_SUBPORTFOLIO_SUCCESS,
  ADD_BR_SUBPORTFOLIO_FAIL,
  DELETE_BR_SUBPORTFOLIO,
  DELETE_BR_SUBPORTFOLIO_FAIL,
  DELETE_BR_SUBPORTFOLIO_SUCCESS,
  DELETE_BR_ENTITY_FROM_SUBPORTFOLIO_SUCCESS,
  ADD_BR_EXISTING_ENTITY_TO_SUBPORTFOLIO_SUCCESS,
  UPDATE_BR_SUBPORTFOLIO_SUCCESS,
  ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO,
  ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO_SUCCESS,
  ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO_FAIL,
  SET_SUBPORTFOLIO_IN_VIEW,
  FETCH_CLOUD_INTEGRATION_FILES,
  FETCH_CLOUD_INTEGRATION_FILES_SUCCESS,
  FETCH_CLOUD_INTEGRATION_FILES_FAIL,
  UPDATE_ENTITY_NAME,
  UPDATE_ENTITY_NAME_SUCCESS,
  UPDATE_ENTITY_NAME_FAIL,
  // SET_UPDATE_ENTITY_ONBOARDING_PROGRESS, UNSET_UPDATE_ENTITY_ONBAORDING_PROGRESS,

} from "../constants/ActionTypes";
import {SearchableValues} from "../constants/SearchableValues";

const INIT_STATE = {
  entityInView: null,
  portfolios: null,
  subportfolioInView: null,
  cloudIntegrations: null,
  loadingCloudIntegrations: {},
  loadingCloudIntegrationsError: {},
  loadingCloudIntegrationRegistration: {},
  loadingCloudIntegrationRegistrationError: {},
  loadingCloudIntegrationUnregistration: {},
  loadingCloudIntegrationUnregistrationError: {},
  loadingCloudIntegrationData: {},
  loadingCloudIntegrationDataError: {},
  selfEntityId: null,
  selfEntity: null,
  loadingPortfolios: {},
  loadingPortfoliosError: {},
  loadingCycles: {},
  loadingCyclesError: {},
  loadingCycleDetails: {},
  loadingCycleDetailsError: {},
  loadingBRBusinessShares: {},
  loadingBRBusinessSharesError: {},
  loadingAddBRBusinessShare: {},
  loadingAddBRBusinessShareError: {},
  loadingAddBRPortfolioEntity: {},
  loadingAddBBRPortfolioEntityError: {},
  loadingDeleteBRPortfolioEntity: {},
  loadingDeleteBBRPortfolioEntityError: {},
  loadingUpdateBRBusinessShare: {},
  loadingUpdateBRBusinessShareError: {},
  loadingAddBRPortfolioReportRequest: {},
  loadingAddBRPortfolioReportRequestError: {},
  loadingUpdateBRAttacksAuthorized: {},
  loadingUpdateBRAttacksAuthorizedError: {},
  loadingAddBRTargetIpProvided: {},
  loadingUpdateBRTargetIpProvided: {},
  loadingAddBRDomainProvided: {},
  loadingUpdateBRDomainProvided: {},
  loadingAddBRSubdomainProvided: {},
  loadingUpdateBRSubdomainProvided: {},
  loadingAddBRIdentityProvided: {},
  loadingAddBRIdentityProvidedError: {},
  loadingUpdateBRIdentityProvided: {},
  loadingUpdateBRIdentityProvidedError: {},
  loadingAddBRValidation: {},
  loadingCycleTargets: {},
  loadingCycleTargetsError: {},
  loadingTargetDetails: {},
  loadingTargetDetailsError: {},
  loadingCycleSocial: {},
  loadingCycleSocialError:{},
  loadingIdentityDetails: {},
  loadingIdentityDetailsError: {},
  loadingUpdateBRSocialTestsAuthorized: {},
  loadingUpdateBRSocialTestsAuthorizedError: {},
  loadingEntityTags: {},
  loadingEntityTagsError: {},
  updateEntityOnboardingProgress: null,
  loadingVectorResults: {},
  loadingVectorResultsError: {},
  loadingUpdateEntityName:{},
  loadingUpdateEntityNameError: {},
  // search: SearchableValues,
  loadingSearchValues: {},
  errorLoadingSearchValues: {},
  // loadingAddTag: {},
  // loadingAddTagError: {},
  // loadingUpdateTag: {},
  // loadingUpdateTagError: {},
  appMisc: {
    didJustCreateNewShare: null,
    didJustAddPortfolioEntity: null,
    didJustAddPortfolioReportRequest: null,
    didJustCreateNewTargetIpProvided: null,
    didJustCreateNewDomainProvided: null,
    didJustCreateNewSubdomainProvided: null,
    didJustCreateNewIdentityProvided: null,
    didJustCreateNewValidation: null,
    didJustRegisterCloudIntegration: null,
    didJustUnregisterCloudIntegration: null,
    // didJustAddEntityTag: null,

  }
};

export default (state = INIT_STATE, action) => {
  let UPDATE_TAG_FAIL;
  switch (action.type) {

    case BREACHRISK_REINIT_STATE: {
      // console.log("Received action CUSTOMER_REINIT_STATE Returning INIT_STATE.");
      return {
        ...INIT_STATE,
      }
    }

      /***********************************
       * SET_ENTITY_IN_VIEW
       ***********************************/

    case SET_ENTITY_IN_VIEW: {
      return {
        ...state,
        entityInView: action.payload
      }
    }

      /***********************************
       * SET_SUBPORTFOLIO_IN_VIEW
       ***********************************/

    case SET_SUBPORTFOLIO_IN_VIEW: {
      return {
        ...state,
        subportfolioInView: action.payload
      }
    }

    /***********************************
     * FETCH_PORTFOLIO
     ***********************************/

    case FETCH_PORTFOLIO:
    case    ADD_BR_SUBPORTFOLIO:
    case    DELETE_BR_SUBPORTFOLIO: {
      const customerId = action.payload.customerId;
      return {
        ...state,
        loadingPortfolios: {
          ...state.loadingPortfolios,
          [customerId] : true,
        },
        loadingPortfoliosError: {
          ...state.loadingPortfoliosError,
          [customerId] : false,
        },
      }
    }

    case FETCH_PORTFOLIO_SUCCESS:
    case ADD_BR_SUBPORTFOLIO_SUCCESS:
    case DELETE_BR_SUBPORTFOLIO_SUCCESS: {
      //if the portfolios were null before this, initialize
      
      const customerId = action.payload.customerId;
      const newPortfolioData = action.payload.inboundData;

      let self_entity_id = null;
      //until john implements self_entity_id, go ahead and infer it if the portfolio auth size is 1
      try{
        if (newPortfolioData.meta && !!newPortfolioData.meta.self_entity_id) {
          //john has implemented self_entity_id
          self_entity_id = newPortfolioData.meta.self_entity_id;
        } else if(newPortfolioData.meta && newPortfolioData.meta.auth_portfolio_size && newPortfolioData.meta.auth_portfolio_size === 1) {
          //john hasn't implemented it yet, so infer that if the size is 1 then the self_entity_id is the id of the only record
          self_entity_id = Object.keys(newPortfolioData.entities)[0]
          console.warn("Forced to infer that self_entity_id is", self_entity_id, "newPortfolioData.meta.self_entity_id was", newPortfolioData.meta.self_entity_id);
        } else {
          // some issue
        }
      } catch (e) {
        console.warn(e);
      }

      console.log(`FETCH_PORTFOLI_SUCCESS has been called, should set loadingPortfolios[${customerId} to ${!state.loadingPortfolios[customerId]}`)
      if (!state.portfolios) {
        return {
          ...state,
          portfolios: {
            [customerId] : newPortfolioData
          },

          //if the self entity id was found, update the state
          selfEntityId: self_entity_id ? self_entity_id : state.selfEntityId,

          loadingPortfolios: {
            ...state.loadingPortfolios,
            [customerId] : false,
          },
          loadingPortfoliosError: {
            ...state.loadingPortfoliosError,
            [customerId] : false,
          },

          appMisc : {
            ...state.appMisc,
            didJustAddEntityTag: {
              ...state.appMisc.didJustAddEntityTag,
              [customerId]: false,
            }
          }
        }
      } else {
        return {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : newPortfolioData
          },

          //if the self entity id was found, update the state
          selfEntityId: self_entity_id ? self_entity_id : state.selfEntityId,

          loadingPortfolios: {
            ...state.loadingPortfolios,
            [customerId] : false,
          },
          loadingPortfoliosError: {
            ...state.loadingPortfoliosError,
            [customerId] : false,
          },

          appMisc : {
            ...state.appMisc,
            didJustAddEntityTag: {
              ...state.appMisc.didJustAddEntityTag,
              [customerId]: false,
            }
          }
        }
      }
    }

    case FETCH_PORTFOLIO_FAIL:
    case ADD_BR_SUBPORTFOLIO_FAIL:
    case DELETE_BR_SUBPORTFOLIO_FAIL: {
      const customerId = action.payload.customerId;
      return {
        ...state,
        loadingPortfolios: {
          ...state.loadingPortfolios,
          [customerId] : false,
        },
        loadingPortfoliosError: {
          ...state.loadingPortfoliosError,
          [customerId] : true,
        },
      }
    }

      /***********************************
       * FETCH_CYCLE_REPORT
       ***********************************/

    case FETCH_CYCLE_REPORT: {
      const cycleId = action.payload.cycleId
      return {
        ...state,
        loadingCycles: {
          ...state.loadingCycles,
          [cycleId] : true,
        },
        loadingCyclesError: {
          ...state.loadingCyclesError,
          [cycleId] : false,
        },
      }
    }

    case FETCH_CYCLE_REPORT_SUCCESS: {
      
      // const entities = state.portfolios[action.payload.customerId].entities
      const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const cycleId = action.payload.cycleId
      const newCycleData = action.payload.inboundData

      const newPortfolioState = state.portfolios[customerId].entities
            && Object.keys(state.portfolios[customerId].entities).includes(entityId)
            ?  {
                ...state.portfolios,
                [customerId] : {
                  ...state.portfolios[customerId],
                  entities: {
                    ...state.portfolios[customerId].entities,
                    [entityId]: {
                      ...state.portfolios[customerId].entities[entityId],
                      cycles: {
                        ...state.portfolios[customerId].entities[entityId].cycles,
                        [cycleId]: newCycleData
                      }
                    }
                  }
                }
              }
              : state.portfolios[customerId].self
              && state.portfolios[customerId].self.id === entityId
                  ? {
                      ...state.portfolios,
                      [customerId] : {
                        ...state.portfolios[customerId],
                        self: {
                          ...state.portfolios[customerId].self,
                            cycles: {
                              ...state.portfolios[customerId].self.cycles,
                              [cycleId]: newCycleData
                            }
                        }
                      }
                    }
                : state.portfolios

      return {
          ...state,
        portfolios: newPortfolioState,

          loadingCycles: {
            ...state.loadingCycles,
            [cycleId] : false,
          },
          loadingCyclesError: {
            ...state.loadingCyclesError,
            [cycleId] : false,
          },
      }
    }

    case FETCH_CYCLE_REPORT_FAIL: {
      const cycleId = action.payload.cycleId
      return {
        ...state,
        loadingCycles: {
          ...state.loadingCycles,
          [cycleId] : false,
        },
        loadingCyclesError: {
          ...state.loadingCyclesError,
          [cycleId] : true,
        },
      }
    }

      /***********************************
       * FETCH_CYCLE_DETAILS
       ***********************************/

    case FETCH_CYCLE_DETAILS: {
      const cycleId = action.payload.cycleId
      return {
        ...state,
        loadingCycleDetails: {
          ...state.loadingCycleDetails,
          [cycleId] : true,
        },
        loadingCycleDetailsError: {
          ...state.loadingCycleDetailsError,
          [cycleId] : false,
        },
      }
    }

    case FETCH_CYCLE_DETAILS_SUCCESS: {

      // const entities = state.portfolios && state.portfolios[action.payload.customerId] ? state.portfolios[action.payload.customerId].entities : null;
      // const entityId = action.payload && action.payload.inboundData ? action.payload.inboundData.entity : null;
      const pageNumberFetched = action.payload.pageNumberFetched;
      const customerId = action.payload.customerId
      const newCycleDetailsData = action.payload && action.payload.inboundData ? action.payload.inboundData : null;

      // console.log("FETCH_CYCLE_DETAILS_SUCCESS here's what we got back", action.payload)

      // Dec 2021 here is what the inbound data looks like with pagewise
      // but if &page=1 was not sent, the meta object is not sent
      // {
      //   "id": "0815c9ef-7e72-438b-8383-49a77d28caef",
      //     "entity": "405275c6-071c-4583-b295-3c9ee332252f",
      //     "meta": {
      //         "pages": 2,
      //         "page_size": 100,
      //         "vectors": 6,
      //         "services": 40,
      //         "subdomains": 101,
      //         "vulnerabilities": 0
      //      },
      //   "totals": {
      //       "targets": 38,
      //       "targets_with_vulns": 0,
      //       "vuln_targets": [],
      //       "active_services": 40,
      //       "active_services_high_risk": 1,
      //       "active_services_detail": {},
      //       "vulnerabilities_detail": {},
      //       "subdomains": {},
      //       "vectors": {}
      //     }
      // }

      const cycleId = newCycleDetailsData ? newCycleDetailsData.id : null;
      const entityId = newCycleDetailsData ?  newCycleDetailsData.entity : null;
      const meta = newCycleDetailsData ?  newCycleDetailsData.meta : null;
      const totals = newCycleDetailsData ?  newCycleDetailsData.totals : null;

      //There are 2 major cases where this has been fetched: 1 when a BRfB user is fetching for the first time in the session
      //2 when an admin is viewing a BRP account and wants to see the tech data for an entity that isn't a customer.
      //so figure out for each of these cases where in the state this data should go.

      //TODO: Copy this logic to FETCH_CYCLE_TARGETS?
      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfTechData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId
          && customerStateLocation.self.cycles //if this is a self entity
          && cycleId
          && customerStateLocation.self.cycles[cycleId])

      const isBRPTechData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId]
          && customerStateLocation.entities[entityId].cycles
          && cycleId
          && customerStateLocation.entities[entityId].cycles[cycleId])

      const techDataStateLocation = isSelfTechData
                  ? customerStateLocation.self.cycles[cycleId].techData
                    ? customerStateLocation.self.cycles[cycleId].techData
                    : {}
                  : isBRPTechData
                    ? customerStateLocation.entities[entityId].cycles[cycleId].techData
                      ? customerStateLocation.entities[entityId].cycles[cycleId].techData
                      : {}
                    : null

      console.log("FETCH_CYCLE_DETAILS_SUCCESS", "isSelfTechData", isSelfTechData, "isBRPTechData", isBRPTechData, "techDataStateLocation is", techDataStateLocation);

      //track the highest page number... This may need to eventually be replaced with something less optimistic.
      //for now, assume that the highest page number implies that all lower page numbers have already been fetched
      const lastHighestPageFetched = meta.highestPageFetched ? meta.highestPageFetched : 0;
      const highestPageFetched = lastHighestPageFetched < pageNumberFetched ? pageNumberFetched : lastHighestPageFetched;
      //add the highestpage fetched into the meta part
      meta.highestPageFetched = highestPageFetched;

      console.log("FETCH_CYCLE_DETAILS_SUCCESS reducer state tree is ", state, "about to insert", newCycleDetailsData)

      //check to see if that cycle already exists in the state tree.
      //if it does, then insert this data into a new techData object
      //if it doesn't, then create a new cycle and insert the tech data
      if(techDataStateLocation
      ) {
        console.log("FETCH_CYCLE_DETAILS_SUCCESS Found a cycle for fetchdetails reducer. splicing new data into existing. newCycleDetailsData", newCycleDetailsData, "existing:", techDataStateLocation, "meta", meta);

        //since there is meta this must be a pagewise call, so we need to build the new totals object by adding the new data
        //these are scalar values and can be overwritten
        const targets = totals ? totals.targets : null;
        const targets_with_vulns_total = totals ? totals.targets_with_vulns_total : null;
        const active_services_total = totals ? totals.active_services_total : null;
        const active_services_high_risk_total = totals ? totals.active_services_high_risk_total : null;

        //these are ARRRAYYS and must be spliced

        //this used to be an array of vulnerable target IDs but was removed to save API time
        // const oldVuln_targets = state.portfolios[customerId].self.cycles[cycleId].techData ? state.portfolios[customerId].self.cycles[cycleId].techData.totals.vuln_targets : [];
        // const newVuln_targets = totals ? totals.vuln_targets : [];
        // const vuln_targets = oldVuln_targets.concat(newVuln_targets);

        const old_active_services_detail = techDataStateLocation.totals ? techDataStateLocation.totals.active_services_detail : [];
        const new_active_services_detail = totals ? totals.active_services_detail : [];
        const active_services_detail = old_active_services_detail.concat(new_active_services_detail)

        const old_vulnerabilities_detail = techDataStateLocation.totals ? techDataStateLocation.totals.vulnerabilities_detail : [];
        const new_vulnerabilities_detail = totals ? totals.vulnerabilities_detail : [];
        const vulnerabilities_detail = old_vulnerabilities_detail.concat(new_vulnerabilities_detail)

        const old_subdomains = techDataStateLocation.totals ? techDataStateLocation.totals.subdomains : [];
        const new_subdomains = totals ? totals.subdomains : [];
        const subdomains = old_subdomains.concat(new_subdomains)

        const old_vectors = techDataStateLocation.totals ? techDataStateLocation.totals.vectors : [];
        const new_vectors = totals ? totals.vectors : [];
        const vectors = old_vectors.concat(new_vectors)

        const updatedTechDataTotals = {
          // ...state.portfolios[customerId].self.cycles[cycleId].techData.totals,
          ...techDataStateLocation
              ? techDataStateLocation.totals
              : {},
          ...newCycleDetailsData.totals,
          targets: (targets !== null) ? targets : null,
          targets_with_vulns_total: (targets_with_vulns_total !== null) ? targets_with_vulns_total : null,
          // vuln_targets,
          active_services_total: (active_services_total !== null) ? active_services_total : null,
          active_services_high_risk_total: (active_services_high_risk_total !== null) ? active_services_high_risk_total : null,
          active_services_detail,
          vulnerabilities_detail,
          subdomains,
          vectors
        }

        // console.log("FETCH_CYCLE_DETAILS_SUCCESS rewiring meta and totals. Here is the state at techDataStateLocation", techDataStateLocation);


        if (isSelfTechData) {
          const newIsSelfTechData =  {
            ...state,
            portfolios: {
              ...state.portfolios,
              [customerId] : {
                ...state.portfolios[customerId],
                self: {
                  ...state.portfolios[customerId].self,
                  cycles: {
                    ...state.portfolios[customerId].self.cycles,
                    [cycleId]: {
                      ...state.portfolios[customerId].self.cycles[cycleId],
                      techData: {
                        ...newCycleDetailsData,
                        totals: updatedTechDataTotals

                      }
                    }
                  }

                }
              }
            },

            loadingCycleDetails: {
              ...state.loadingCycleDetails,
              [cycleId] : false,
            },
            loadingCycleDetailsError: {
              ...state.loadingCycleDetailsError,
              [cycleId] : false,
            },
          }

          console.log("New state for newIsSelfTechData will be", newIsSelfTechData, "returning now");
          return newIsSelfTechData;
        } else if(isBRPTechData) {
          const newIsBRPTechDataState =  {
            ...state,
            portfolios: {
              ...state.portfolios,
              [customerId]: {
                ...state.portfolios[customerId],
                entities: {
                  ...state.portfolios[customerId].entities,
                  [entityId] : {
                    ...state.portfolios[customerId].entities[entityId],
                    cycles: {
                      ...state.portfolios[customerId].entities[entityId].cycles,
                      [cycleId]: {
                        ...state.portfolios[customerId].entities[entityId].cycles[cycleId],
                        techData: {
                          ...newCycleDetailsData,
                          totals: updatedTechDataTotals

                        }
                      }
                    }
                  }
                }
              }
            },

            loadingCycleDetails: {
              ...state.loadingCycleDetails,
              [cycleId]: false,
            },
            loadingCycleDetailsError: {
              ...state.loadingCycleDetailsError,
              [cycleId]: false,
            },
          }

          console.log("New newIsBRPTechDataState will be", newIsBRPTechDataState, "Returning to state handler", "state.portfolios[customerId].entities[entityId].cycles[cycleId]", state.portfolios[customerId].entities[entityId].cycles[cycleId]);
          return newIsBRPTechDataState;

        } else { //some sort of problem happened.
          console.warn("Cannot update state with tech details. Error knowing where to put the data");
          return {
            ...state,

            loadingCycleDetails: {
            ...state.loadingCycleDetails,
                  [cycleId] : false,
            },
            loadingCycleDetailsError: {
            ...state.loadingCycleDetailsError,
                  [cycleId] : false,
            },
          }
        }
      }
      // else if(state.portfolios //if it doesn't, then create a new cycle and insert the tech data. as of 29 aug '21, there may not be a difference in this branch
      //     && state.portfolios[customerId]
      //     && state.portfolios[customerId].self
      //     && state.portfolios[customerId].self.id === entityId
      //     && state.portfolios[customerId].self.cycles
      //     && state.portfolios[customerId].self.cycles[cycleId]
      //     && !state.portfolios[customerId].self.cycles[cycleId].techData
      // ) {
      //   console.log("FETCH_CYCLE_DETAILS_SUCCESS Cycle details reducer found details for a cycle but without techData in the state tree.", state.portfolios[customerId].self);
      //   return {
      //     ...state,
      //     portfolios: {
      //       ...state.portfolios,
      //       [customerId] : {
      //         ...state.portfolios[customerId],
      //         self: {
      //           ...state.portfolios[customerId].self,
      //             cycles: {
      //               ...state.portfolios[customerId].self.cycles,
      //               [cycleId]: {
      //                 ...state.portfolios[customerId].self.cycles[cycleId],
      //                 techData: newCycleDetailsData
      //               }
      //             }
      //           }
      //
      //       }
      //     },
      //
      //     loadingCycleDetails: {
      //       ...state.loadingCycleDetails,
      //       [cycleId] : false,
      //     },
      //     loadingCycleDetailsError: {
      //       ...state.loadingCycleDetailsError,
      //       [cycleId] : false,
      //     },
      //   }
      // }
      // else if(state.portfolios //if this is for an admin that is looking at a portfolio entity
      //     && state.portfolios[customerId]
      //     && state.portfolios[customerId].entities
      //     && Object.keys(state.portfolios[customerId].entities).includes(entityId)
      //     && state.portfolios[customerId].entities[entityId]
      //     && state.portfolios[customerId].entities[entityId].cycles
      //     && state.portfolios[customerId].entities[entityId].cycles[cycleId]
      //     && !state.portfolios[customerId].entities[entityId].cycles[cycleId].techData
      // ) {
      //   console.log("FETCH_CYCLE_DETAILS_SUCCESS as admin viewing Found a cycle for fetchdetails reducer. splicing new data into existing. newCycleDetailsData", newCycleDetailsData, "existing:", state.portfolios[customerId].entities[entityId].cycles[cycleId].techData, "meta", meta);
      //
      //   //since there is meta this must be a pagewise call, so we need to build the new totals object by adding the new data
      //   //these are scalar values and can be overwritten
      //   const targets = totals ? totals.targets : null;
      //   const targets_with_vulns_total = totals ? totals.targets_with_vulns_total : null;
      //   const active_services_total = totals ? totals.active_services_total : null;
      //   const active_services_high_risk_total = totals ? totals.active_services_high_risk_total : null;
      //
      //   //these are ARRRAYYS and must be spliced
      //
      //   //this used to be an array of vulnerable target IDs but was removed to save API time
      //   // const oldVuln_targets = state.portfolios[customerId].entities[entityId].cycles[cycleId].techData ? state.portfolios[customerId].entities[entityId].cycles[cycleId].techData.totals.vuln_targets : [];
      //   // const newVuln_targets = totals ? totals.vuln_targets : [];
      //   // const vuln_targets = oldVuln_targets.concat(newVuln_targets);
      //
      //   const old_active_services_detail = state.portfolios[customerId].entities[entityId].cycles[cycleId].techData ? state.portfolios[customerId].entities[entityId].cycles[cycleId].techData.totals.active_services_detail : [];
      //   const new_active_services_detail = totals ? totals.active_services_detail : [];
      //   const active_services_detail = old_active_services_detail.concat(new_active_services_detail)
      //
      //   const old_vulnerabilities_detail = state.portfolios[customerId].entities[entityId].cycles[cycleId].techData ? state.portfolios[customerId].entities[entityId].cycles[cycleId].techData.totals.vulnerabilities_detail : [];
      //   const new_vulnerabilities_detail = totals ? totals.vulnerabilities_detail : [];
      //   const vulnerabilities_detail = old_vulnerabilities_detail.concat(new_vulnerabilities_detail)
      //
      //   const old_subdomains = state.portfolios[customerId].entities[entityId].cycles[cycleId].techData ? state.portfolios[customerId].entities[entityId].cycles[cycleId].techData.totals.subdomains : [];
      //   const new_subdomains = totals ? totals.subdomains : [];
      //   const subdomains = old_subdomains.concat(new_subdomains)
      //
      //   const old_vectors = state.portfolios[customerId].entities[entityId].cycles[cycleId].techData ? state.portfolios[customerId].entities[entityId].cycles[cycleId].techData.totals.vectors : [];
      //   const new_vectors = totals ? totals.vectors : [];
      //   const vectors = old_vectors.concat(new_vectors)
      //
      //   const updatedTechDataTotals = {
      //     ...state.portfolios[customerId].entities[entityId].cycles[cycleId].techData
      //           ? state.portfolios[customerId].entities[entityId].cycles[cycleId].techData.totals
      //           : {},
      //     // targets,
      //     // targets_with_vulns_total,
      //     // vuln_targets,
      //     // active_services_total,
      //     // active_services_high_risk_total,
      //     active_services_detail,
      //     vulnerabilities_detail,
      //     subdomains,
      //     vectors
      //   }
      //
      //   console.log("FETCH_CYCLE_DETAILS_SUCCESS as admin viewing rewiring meta and totals. Here is the state at state.portfolios[customerId].self.cycles[cycleId]", state.portfolios[customerId].entities[entityId].cycles[cycleId]);
      //
      //   return {
      //     ...state,
      //     portfolios: {
      //       ...state.portfolios,
      //       [customerId]: {
      //         ...state.portfolios[customerId],
      //         entities: {
      //           ...state.portfolios[customerId].entities,
      //           [entityId] : {
      //             ...state.portfolios[customerId].entities[entityId],
      //             cycles: {
      //               ...state.portfolios[customerId].entities[entityId].cycles,
      //               [cycleId]: {
      //                 ...state.portfolios[customerId].entities[entityId].cycles[cycleId],
      //                 techData: {
      //                   ...newCycleDetailsData,
      //                   totals: updatedTechDataTotals
      //
      //                 }
      //               }
      //             }
      //           }
      //         }
      //       }
      //     },
      //
      //     loadingCycleDetails: {
      //       ...state.loadingCycleDetails,
      //       [cycleId]: false,
      //     },
      //     loadingCycleDetailsError: {
      //       ...state.loadingCycleDetailsError,
      //       [cycleId]: false,
      //     },
      //   }
      // }
      else { //there must be some problem where we don't have the chain of parents, so throw an error
        console.warn("FETCH_CYCLE_DETAILS_SUCCESS Cycle details reducer there must be some problem where we don't have the chain of parents.");
        return {
          ...state,
          loadingCycleDetails: {
            ...state.loadingCycleDetails,
            [cycleId] : false,
          },
          loadingCycleDetailsError: {
            ...state.loadingCycleDetailsError,
            [cycleId] : true,
          },
        }
      }

    }

    case FETCH_CYCLE_DETAILS_FAIL: {
      const cycleId = action.payload.cycleId
      return {
        ...state,
        loadingCycleDetails: {
          ...state.loadingCycleDetails,
          [cycleId] : false,
        },
        loadingCycleDetailsError: {
          ...state.loadingCycleDetailsError,
          [cycleId] : true,
        },
      }
    }

      /***********************************
       * FETCH_BR_BUSINESS_SHARES
       ***********************************/

    case FETCH_BR_BUSINESS_SHARES: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingBRBusinessShares: {
          ...state.loadingBRBusinessShares,
          [customerId] : true,
        },
        loadingBRBusinessSharesError: {
          ...state.loadingBRBusinessSharesError,
          [customerId] : false,
        },
      }
    }

    case FETCH_BR_BUSINESS_SHARES_SUCCESS: {

      const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const entityId = action.payload.entityId
      const newBRBusinessSharesData = action.payload.inboundData.shares

      console.log("FETCH_BR_BUSINESS_SHARES_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRBusinessSharesData, "for these entities", entities, "for this entityId", entityId);

      return {
        ...state,
        portfolios: {
          ...state.portfolios,
          [customerId] : {
            ...state.portfolios[customerId],
            // entities: {
            //   ...state.portfolios[customerId].entities,
            //   [entityId]: {
            //     ...state.portfolios[customerId].entities[entityId],
                shares: newBRBusinessSharesData
            //   }
            // }
          }
        },

        loadingBRBusinessShares: {
          ...state.loadingBRBusinessShares,
          [customerId] : false,
        },
        loadingBRBusinessSharesError: {
          ...state.loadingBRBusinessSharesError,
          [customerId] : false,
        },
      }
    }

    case FETCH_BR_BUSINESS_SHARES_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingBRBusinessShares: {
          ...state.loadingBRBusinessShares,
          [customerId] : false,
        },
        loadingBRBusinessSharesError: {
          ...state.loadingBRBusinessSharesError,
          [customerId] : true,
        },
      }
    }

      /***********************************
       * ADD_BR_BUSINESS_SHARE
       ***********************************/

    case ADD_BR_BUSINESS_SHARE: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRBusinessShare: {
          ...state.loadingAddBRBusinessShare,
          [customerId] : true,
        },
        loadingAddBRBusinessShareError: {
          ...state.loadingAddBRBusinessShareError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewShare: null
        },
      }
    }

    case ADD_BR_BUSINESS_SHARE_SUCCESS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      // const entityId = action.payload.entityId
      const newBRBusinessShareData = action.payload.inboundData

      console.log("ADD_BR_BUSINESS_SHARE_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRBusinessShareData, );

      return {
        ...state,
        portfolios: {
          ...state.portfolios,
          [customerId] : {
            ...state.portfolios[customerId],
            // entities: {
            //   ...state.portfolios[customerId].entities,
            //   [entityId]: {
            //     ...state.portfolios[customerId].entities[entityId],
                shares: {
                  ...state.portfolios[customerId].shares,
                  [newBRBusinessShareData.id]: newBRBusinessShareData
                }
            //   }
            // }
          }
        },

        loadingAddBRBusinessShare: {
          ...state.loadingAddBRBusinessShare,
          [customerId] : false,
        },
        loadingAddBRBusinessShareError: {
          ...state.loadingAddBRBusinessShareError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewShare: true
        },
      }
    }

    case ADD_BR_BUSINESS_SHARE_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRBusinessShare: {
          ...state.loadingAddBRBusinessShare,
          [customerId] : false,
        },
        loadingAddBRBusinessShareError: {
          ...state.loadingAddBRBusinessShareError,
          [customerId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewShare: false
        },
      }
    }

      /***********************************
       * UPDATE_BR_BUSINESS_SHARE
       ***********************************/

    case UPDATE_BR_BUSINESS_SHARE: {
      const shareId = action.payload.shareId
      return {
        ...state,
        loadingUpdateBRBusinessShare: {
          ...state.loadingUpdateBRBusinessShare,
          [shareId] : true,
        },
        loadingUpdateBRBusinessShareError: {
          ...state.loadingUpdateBRBusinessShareError,
          [shareId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewShare: null
        },
      }
    }

    case UPDATE_BR_BUSINESS_SHARE_SUCCESS: {

      //result will be a new record to replace the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const shareId = action.payload.shareId
      const newBRBusinessShareData = action.payload.inboundData

      // console.log("UPDATE_BR_BUSINESS_SHARE_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRBusinessSharesData, "for these entities", entities, "for this entityId", entityId);
      console.log("UPDATE_BR_BUSINESS_SHARE_SUCCESS about to update state, this is the information for customerId", customerId, "shareId", shareId, "newBRBusinessShareData", newBRBusinessShareData  )
      return {
        ...state,
        portfolios: {
          ...state.portfolios,
          [customerId] : {
            ...state.portfolios[customerId],
            // entities: {
            //   ...state.portfolios[customerId].entities,
            //   [entityId]: {
            //     ...state.portfolios[customerId].entities[entityId],
                shares: {
                  ...state.portfolios[customerId].shares,
                  [newBRBusinessShareData.id]: newBRBusinessShareData
                }
            //   }
            // }
          }
        },

        loadingUpdateBRBusinessShare: {
          ...state.loadingUpdateBRBusinessShare,
          [shareId] : false,
        },
        loadingUpdateBRBusinessShareError: {
          ...state.loadingUpdateBRBusinessShareError,
          [shareId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewShare: true
        },
      }
    }

    case UPDATE_BR_BUSINESS_SHARE_FAIL: {
      const shareId = action.payload.shareId
      return {
        ...state,
        loadingUpdateBRBusinessShare: {
          ...state.loadingUpdateBRBusinessShare,
          [shareId] : false,
        },
        loadingUpdateBRBusinessShareError: {
          ...state.loadingUpdateBRBusinessShareError,
          [shareId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewShare: false
        },
      }
    }


      /***********************************
       * ADD_BR_PORTFOLIO_ENTITY
       ***********************************/

    case ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO:
    case ADD_BR_PORTFOLIO_ENTITY: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRPortfolioEntity: {
          ...state.loadingAddBRPortfolioEntity,
          [customerId] : true,
        },
        loadingAddBRPortfolioEntityError: {
          ...state.loadingAddBRPortfolioEntityError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustAddPortfolioEntity: null
        },
      }
    }

    case ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO_SUCCESS:
    case ADD_BR_PORTFOLIO_ENTITY_SUCCESS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      // const entityId = action.payload.entityId
      const newBRPortfolioData = action.payload.inboundData

      // console.log("BR_PORTFOLIO_ENTITY_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRBusinessSharesData, "for these entities", entities, "for this entityId", entityId);

      return {
        ...state,
        portfolios: {
          ...state.portfolios,
          [customerId] : newBRPortfolioData
        },

        loadingAddBRPortfolioEntity: {
          ...state.loadingAddBRPortfolioEntity,
          [customerId] : false,
        },
        loadingAddBRPortfolioEntityError: {
          ...state.loadingAddBRPortfolioEntityError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustAddPortfolioEntity: true
        },
      }
    }

    case ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO_FAIL:
    case ADD_BR_PORTFOLIO_ENTITY_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRPortfolioEntity: {
          ...state.loadingAddBRPortfolioEntity,
          [customerId] : false,
        },
        loadingAddBRPortfolioEntityError: {
          ...state.loadingAddBRPortfolioEntityError,
          [customerId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustAddPortfolioEntity: false
        },
      }
    }

      /***********************************
       * DELETE_BR_PORTFOLIO_ENTITY
       ***********************************/

    case DELETE_BR_PORTFOLIO_ENTITY: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingDeleteBRPortfolioEntity: {
          ...state.loadingDeleteBRPortfolioEntity,
          [customerId] : true,
        },
        loadingDeleteBRPortfolioEntityError: {
          ...state.loadingDeleteBRPortfolioEntityError,
          [customerId] : false,
        },

      }
    }

    case DELETE_BR_PORTFOLIO_ENTITY_SUCCESS: {

      //result will be a new record to delete to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      // const entityId = action.payload.entityId
      const newBRPortfolioData = action.payload.inboundData

      // console.log("BR_PORTFOLIO_ENTITY_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRBusinessSharesData, "for these entities", entities, "for this entityId", entityId);
      console.log(`BR_PORTFOLIO_SUCCESS CALLED SHOULD SET loadingDEleteBRPortfolioEntity[${customerId}] to ${!state.loadingDeleteBRPortfolioEntity[customerId]}`)
      return {
        ...state,
        portfolios: {
          ...state.portfolios,
          [customerId] : newBRPortfolioData
        },

        loadingDeleteBRPortfolioEntity: {
          ...state.loadingDeleteBRPortfolioEntity,
          [customerId] : false,
        },
        loadingDeleteBRPortfolioEntityError: {
          ...state.loadingDeleteBRPortfolioEntityError,
          [customerId] : false,
        },

      }
    }

    case DELETE_BR_PORTFOLIO_ENTITY_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingDeleteBRPortfolioEntity: {
          ...state.loadingDeleteBRPortfolioEntity,
          [customerId] : false,
        },
        loadingDeleteBRPortfolioEntityError: {
          ...state.loadingDeleteBRPortfolioEntityError,
          [customerId] : true,
        },

      }
    }


      /***********************************
       * ADD_BR_PORTFOLIO_REPORT_REQUEST
       ***********************************/

    case ADD_BR_PORTFOLIO_REPORT_REQUEST: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRPortfolioReportRequest: {
          ...state.loadingAddBRPortfolioReportRequest,
          [customerId] : true,
        },
        loadingAddBRPortfolioReportRequestError: {
          ...state.loadingAddBRPortfolioReportRequestError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustAddPortfolioReportRequest: null
        },
      }
    }

    case ADD_BR_PORTFOLIO_REPORT_REQUEST_SUCCESS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      // const entityId = action.payload.entityId
      const newBRPortfolioData = action.payload.inboundData

      // console.log("BR_PORTFOLIO_ENTITY_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRBusinessSharesData, "for these entities", entities, "for this entityId", entityId);
      console.log("BR_PORTFOLIO_repoRT_REQUEST_SUCCSESS REDUCER, inboudndata looks like", newBRPortfolioData)


      return {
        ...state,
        portfolios: {
          ...state.portfolios,
          [customerId] : {
            ...state.portfolios[customerId],
            shares: {
              ...state.portfolios[customerId].shares,
              [newBRPortfolioData.id]: newBRPortfolioData
            }
          }
        },

        loadingAddBRPortfolioReportRequest: {
          ...state.loadingAddBRPortfolioReportRequest,
          [customerId] : false,
        },
        loadingAddBRPortfolioReportRequestError: {
          ...state.loadingAddBRPortfolioReportRequestError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustAddPortfolioReportRequest: true
        },
      }
    }

    case ADD_BR_PORTFOLIO_REPORT_REQUEST_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRPortfolioReportRequest: {
          ...state.loadingAddBRPortfolioReportRequest,
          [customerId] : false,
        },
        loadingAddBRPortfolioReportRequestError: {
          ...state.loadingAddBRPortfolioReportRequestError,
          [customerId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustAddPortfolioReportRequest: false
        },
      }
    }

      /***********************************
       * UPDATE_BR_BUSINESS_SHARE
       ***********************************/

    case UPDATE_BR_ATTACKS_AUTHORIZED: {
      const entityId = action.payload.entityId
      return {
        ...state,
        loadingUpdateBRAttacksAuthorized: {
          ...state.loadingUpdateBRAttacksAuthorized,
          [entityId] : true,
        },
        loadingUpdateBRAttacksAuthorizedError: {
          ...state.loadingUpdateBRAttacksAuthorizedError,
          [entityId] : false,
        },
      }
    }

    case UPDATE_BR_ATTACKS_AUTHORIZED_SUCCESS: {

      // const entities = state.portfolios[action.payload.customerId].entities
      const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      // const entityId = action.payload.entityId
      const newBRAttacksAuthorizedData = action.payload.inboundData

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      console.log("UPDATE_BR_ATTACKS_AUTHORIZED_SUCCESS here is the inboundData", action.payload.inboundData)
      if (isSelfData) {
        return {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                settings: newBRAttacksAuthorizedData
              }
            }
          },

          loadingUpdateBRAttacksAuthorized: {
            ...state.loadingUpdateBRAttacksAuthorized,
            [entityId]: false,
          },
          loadingUpdateBRAttacksAuthorizedError: {
            ...state.loadingUpdateBRAttacksAuthorizedError,
            [entityId]: false,
          },
        }
      } else if (isBRPData) {
        return {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId]: {
                  ...state.portfolios[customerId].entities[entityId],
                  settings: newBRAttacksAuthorizedData
                }
              }
            }
          },
          loadingUpdateBRAttacksAuthorized: {
            ...state.loadingUpdateBRAttacksAuthorized,
            [entityId]: false,
          },
          loadingUpdateBRAttacksAuthorizedError: {
            ...state.loadingUpdateBRAttacksAuthorizedError,
            [entityId]: false,
          },
        }
      } else {
        return {
          loadingUpdateBRAttacksAuthorized: {
            ...state.loadingUpdateBRAttacksAuthorized,
            [entityId]: false,
          },
          loadingUpdateBRAttacksAuthorizedError: {
            ...state.loadingUpdateBRAttacksAuthorizedError,
            [entityId]: false,
          },
        }
      }
    }



    case UPDATE_BR_ATTACKS_AUTHORIZED_FAIL: {
      const entityId = action.payload.entityId
      return {
        ...state,
        loadingUpdateBRAttacksAuthorized: {
          ...state.loadingUpdateBRAttacksAuthorized,
          [entityId] : false,
        },
        loadingUpdateBRAttacksAuthorizedError: {
          ...state.loadingUpdateBRAttacksAuthorizedError,
          [entityId] : true,
        },
      }
    }

      /***********************************
       * ADD_BR_TARGETIP_PROVIDED
       ***********************************/

    case ADD_BR_TARGETIP_PROVIDED: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRTargetIpProvided: {
          ...state.loadingAddBRTargetIpProvided,
          [customerId] : true,
        },
        loadingAddBRTargetIpProvidedError: {
          ...state.loadingAddBRTargetIpProvidedError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewTargetIpProvided: null
        },
      }
    }

    case ADD_BR_TARGETIP_PROVIDED_SUCCESS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const entityId = action.payload.entityId
      const newBRTargetIpProvidedData = action.payload.inboundData

      // console.log("ADD_BR_TARGETIP_PROVIDED_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRTargetIpProvidedsData, "for these entities", entities, "for this entityId", entityId);

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfTargetIPProvidedData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPTargetIPProvidedData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      const dataStateLocation = isSelfTargetIPProvidedData
          ? customerStateLocation.self.targets_provided
              ? customerStateLocation.self.targets_provided
              : {}
          : isBRPTargetIPProvidedData
              ? customerStateLocation.entities[entityId].targets_provided
                  ? customerStateLocation.entities[entityId].targets_provided
                  : {}
              : null

      console.log("ADD_BR_TARGETIP_PROVIDED_SUCCESS", "isSelfTargetIPProvidedData", isSelfTargetIPProvidedData, "isBRPTargetIPProvidedData", isBRPTargetIPProvidedData, "dataStateLocation is", dataStateLocation);


      //TODO: keep an eye on this now it has been updated for portfolio

      // return {
      //   ...state,
      //   portfolios: {
      //     ...state.portfolios,
      //     [customerId] : {
      //       ...state.portfolios[customerId],
      //       self: {
      //         ...state.portfolios[customerId].self,
      //         // [entityId]: {
      //         //   ...state.portfolios[customerId].self[entityId],
      //           targets_provided: {
      //             ...state.portfolios[customerId].self.targets_provided,
      //             [newBRTargetIpProvidedData.id]: newBRTargetIpProvidedData
      //           }
      //         }
      //       // }
      //     }
      //   },
      //
      //   loadingAddBRTargetIpProvided: {
      //     ...state.loadingAddBRTargetIpProvided,
      //     [customerId] : false,
      //   },
      //   loadingAddBRTargetIpProvidedError: {
      //     ...state.loadingAddBRTargetIpProvidedError,
      //     [customerId] : false,
      //   },
      //   appMisc: {
      //     ...state.appMisc,
      //     didJustCreateNewTargetIpProvided: true
      //   },
      // }

      if (isSelfTargetIPProvidedData) {
        const newIsSelfTechData =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                // [entityId]: {
                //   ...state.portfolios[customerId].self[entityId],
                targets_provided: {
                  ...state.portfolios[customerId].self.targets_provided,
                  [newBRTargetIpProvidedData.id]: newBRTargetIpProvidedData
                }
              }
              // }
            }
          },

          loadingAddBRTargetIpProvided: {
            ...state.loadingAddBRTargetIpProvided,
            [customerId] : false,
          },
          loadingAddBRTargetIpProvidedError: {
            ...state.loadingAddBRTargetIpProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewTargetIpProvided: true
          },
        }

        console.log("New state for newIsSelfTechData will be", newIsSelfTechData, "returning now");
        return newIsSelfTechData;
      } else if(isBRPTargetIPProvidedData) {
        const newIsBRPTechDataState =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                targets_provided: {
                  ...state.portfolios[customerId].entities[entityId].targets_provided,
                  [newBRTargetIpProvidedData.id]: newBRTargetIpProvidedData
                }
              }
              }
            }
          },

          loadingAddBRTargetIpProvided: {
            ...state.loadingAddBRTargetIpProvided,
            [customerId] : false,
          },
          loadingAddBRTargetIpProvidedError: {
            ...state.loadingAddBRTargetIpProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewTargetIpProvided: true
          },
        }

        console.log("New newIsBRPTechDataState will be", newIsBRPTechDataState, "Returning to state handler", "state.portfolios[customerId].entities[entityId]", state.portfolios[customerId].entities[entityId]);
        return newIsBRPTechDataState;

      } else { //some sort of problem happened.
        console.warn("Cannot update state with tech details. Error knowing where to put the data");
        return {
          ...state,

          loadingAddBRTargetIpProvided: {
            ...state.loadingAddBRTargetIpProvided,
            [customerId] : false,
          },
          loadingAddBRTargetIpProvidedError: {
            ...state.loadingAddBRTargetIpProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewTargetIpProvided: true
          },
        }
      }
    }

    case ADD_BR_TARGETIP_PROVIDED_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRTargetIpProvided: {
          ...state.loadingAddBRTargetIpProvided,
          [customerId] : false,
        },
        loadingAddBRTargetIpProvidedError: {
          ...state.loadingAddBRTargetIpProvidedError,
          [customerId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewTargetIpProvided: false
        },
      }
    }

      /***********************************
       * UPDATE_BR_TARGETIP_PROVIDED Archive delete provided domains
       ***********************************/

    case UPDATE_BR_TARGETIP_PROVIDED: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingUpdateBRTargetIpProvided: {
          ...state.loadingUpdateBRTargetIpProvided,
          [customerId] : true,
        },
        loadingUpdateBRTargetIpProvidedError: {
          ...state.loadingUpdateBRTargetIpProvidedError,
          [customerId] : false,
        },

      }
    }

    case UPDATE_BR_TARGETIP_PROVIDED_SUCCESS: {

      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const entityId = action.payload.entityId
      const newBRTargetIpProvidedData = action.payload.inboundData

      // console.log("BR_PORTFOLIO_ENTITY_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRBusinessSharesData, "for these entities", entities, "for this entityId", entityId);

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfTargetIPProvidedData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPTargetIPProvidedData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      const dataStateLocation = isSelfTargetIPProvidedData
          ? customerStateLocation.self.targets_provided
              ? customerStateLocation.self.targets_provided
              : {}
          : isBRPTargetIPProvidedData
              ? customerStateLocation.entities[entityId].targets_provided
                  ? customerStateLocation.entities[entityId].targets_provided
                  : {}
              : null

      console.log("UPDATE_BR_TARGETIP_PROVIDED_SUCCESS", "isBRPTargetIPProvidedData", isBRPTargetIPProvidedData, "isBRPTargetIPProvidedData", isBRPTargetIPProvidedData, "dataStateLocation is", dataStateLocation);


      //TODO: keep an eye on this now it has been updated for portfolio

      // return {
      //   ...state,
      //   portfolios: {
      //     ...state.portfolios,
      //     [customerId] : {
      //       ...state.portfolios[customerId],
      //       self: {
      //         ...state.portfolios[customerId].self,
      //         // [entityId]: {
      //         //   ...state.portfolios[customerId].entities[entityId],
      //         targets_provided: {
      //           ...state.portfolios[customerId].self.targets_provided,
      //           [newBRTargetIpProvidedData.id]: newBRTargetIpProvidedData
      //         }
      //         // }
      //       }
      //     }
      //   },
      //
      //   loadingUpdateBRTargetIpProvided: {
      //     ...state.loadingUpdateBRTargetIpProvided,
      //     [customerId] : false,
      //   },
      //   loadingUpdateBRTargetIpProvidedError: {
      //     ...state.loadingUpdateBRTargetIpProvidedError,
      //     [customerId] : false,
      //   },
      //
      // }

      if (isSelfTargetIPProvidedData) {
        const newIsSelfTechData = {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                // [entityId]: {
                //   ...state.portfolios[customerId].entities[entityId],
                targets_provided: {
                  ...state.portfolios[customerId].self.targets_provided,
                  [newBRTargetIpProvidedData.id]: newBRTargetIpProvidedData
                }
                // }
              }
            }
          },

          loadingUpdateBRTargetIpProvided: {
            ...state.loadingUpdateBRTargetIpProvided,
            [customerId]: false,
          },
          loadingUpdateBRTargetIpProvidedError: {
            ...state.loadingUpdateBRTargetIpProvidedError,
            [customerId]: false,
          },
        }

        console.log("New state for newIsSelfTechData will be", newIsSelfTechData, "returning now");
        return newIsSelfTechData;
      } else if (isBRPTargetIPProvidedData) {
        const newIsBRPTechDataState = {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId]: {
                  ...state.portfolios[customerId].entities[entityId],
                  targets_provided: {
                    ...state.portfolios[customerId].entities[entityId].targets_provided,
                    [newBRTargetIpProvidedData.id]: newBRTargetIpProvidedData
                  }
                }
              }
            }
          },

          loadingUpdateBRTargetIpProvided: {
            ...state.loadingUpdateBRTargetIpProvided,
            [customerId]: false,
          },
          loadingUpdateBRTargetIpProvidedError: {
            ...state.loadingUpdateBRTargetIpProvidedError,
            [customerId]: false,
          },
        }

        console.log("New newIsBRPTechDataState will be", newIsBRPTechDataState, "Returning to state handler", "state.portfolios[customerId].entities[entityId]", state.portfolios[customerId].entities[entityId]);
        return newIsBRPTechDataState;

      } else { //some sort of problem happened.
        console.warn("Cannot update state with tech details. Error knowing where to put the data");
        return {
          ...state,

          loadingUpdateBRTargetIpProvided: {
            ...state.loadingUpdateBRTargetIpProvided,
            [customerId]: false,
          },
          loadingUpdateBRTargetIpProvidedError: {
            ...state.loadingUpdateBRTargetIpProvidedError,
            [customerId]: false,
          },
        }
      }
    }

    case UPDATE_BR_TARGETIP_PROVIDED_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingUpdateBRTargetIpProvided: {
          ...state.loadingUpdateBRTargetIpProvided,
          [customerId] : false,
        },
        loadingUpdateBRTargetIpProvidedError: {
          ...state.loadingUpdateBRTargetIpProvidedError,
          [customerId] : true,
        },

      }
    }

      /***********************************
       * ADD_BR_DOMAIN_PROVIDED
       ***********************************/

    case ADD_BR_DOMAIN_PROVIDED: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRDomainProvided: {
          ...state.loadingAddBRDomainProvided,
          [customerId] : true,
        },
        loadingAddBRDomainProvidedError: {
          ...state.loadingAddBRDomainProvidedError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewDomainProvided: null
        },
      }
    }

    case ADD_BR_DOMAIN_PROVIDED_SUCCESS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const entityId = action.payload.entityId
      const newBRDomainProvidedData = action.payload.inboundData

      // console.log("ADD_BR_DOMAIN_PROVIDED_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRDomainProvidedsData, "for these entities", entities, "for this entityId", entityId);

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfTargetIPProvidedData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPTargetIPProvidedData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      const dataStateLocation = isSelfTargetIPProvidedData
          ? customerStateLocation.self.domains
              ? customerStateLocation.self.domains
              : {}
          : isBRPTargetIPProvidedData
              ? customerStateLocation.entities[entityId].domains
                  ? customerStateLocation.entities[entityId].domains
                  : {}
              : null

      console.log("ADD_BR_DOMAIN_PROVIDED_SUCCESS", "isSelfTargetIPProvidedData", isSelfTargetIPProvidedData, "isBRPTargetIPProvidedData", isBRPTargetIPProvidedData, "dataStateLocation is", dataStateLocation);


      //TODO: keep an eye on this now it has been updated for portfolio

      // return {
      //   ...state,
      //   portfolios: {
      //     ...state.portfolios,
      //     [customerId] : {
      //       ...state.portfolios[customerId],
      //       self: {
      //         ...state.portfolios[customerId].self,
      //         // [entityId]: {
      //         //   ...state.portfolios[customerId].entities[entityId],
      //         domains: {
      //           ...state.portfolios[customerId].self.domains,
      //           [newBRDomainProvidedData.id]: newBRDomainProvidedData
      //         }
      //         // }
      //       }
      //     }
      //   },
      //
      //   loadingAddBRDomainProvided: {
      //     ...state.loadingAddBRDomainProvided,
      //     [customerId] : false,
      //   },
      //   loadingAddBRDomainProvidedError: {
      //     ...state.loadingAddBRDomainProvidedError,
      //     [customerId] : false,
      //   },
      //   appMisc: {
      //     ...state.appMisc,
      //     didJustCreateNewDomainProvided: true
      //   },
      // }

      if (isSelfTargetIPProvidedData) {
        const newIsSelfTechData =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                // [entityId]: {
                //   ...state.portfolios[customerId].self[entityId],
                domains: {
                  ...state.portfolios[customerId].self.domains,
                  [newBRDomainProvidedData.id]: newBRDomainProvidedData
                }
              }
              // }
            }
          },

          loadingAddBRDomainProvided: {
            ...state.loadingAddBRDomainProvided,
            [customerId] : false,
          },
          loadingAddBRDomainProvidedError: {
            ...state.loadingAddBRDomainProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewDomainProvided: true
          },
        }

        console.log("New state for newIsSelfTechData will be", newIsSelfTechData, "returning now");
        return newIsSelfTechData;
      } else if(isBRPTargetIPProvidedData) {
        const newIsBRPTechDataState =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                  domains: {
                    ...state.portfolios[customerId].entities[entityId].domains,
                    [newBRDomainProvidedData.id]: newBRDomainProvidedData
                  }
                }
              }
            }
          },

          loadingAddBRDomainProvided: {
            ...state.loadingAddBRDomainProvided,
            [customerId] : false,
          },
          loadingAddBRDomainProvidedError: {
            ...state.loadingAddBRDomainProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewDomainProvided: true
          },
        }

        console.log("New newIsBRPTechDataState will be", newIsBRPTechDataState, "Returning to state handler", "state.portfolios[customerId].entities[entityId]", state.portfolios[customerId].entities[entityId]);
        return newIsBRPTechDataState;

      } else { //some sort of problem happened.
        console.warn("Cannot update state added domain details. Error knowing where to put the data");
        return {
          ...state,

          loadingAddBRDomainProvided: {
            ...state.loadingAddBRDomainProvided,
            [customerId] : false,
          },
          loadingAddBRDomainProvidedError: {
            ...state.loadingAddBRDomainProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewDomainProvided: true
          },
        }
      }
    }

    case ADD_BR_DOMAIN_PROVIDED_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRDomainProvided: {
          ...state.loadingAddBRDomainProvided,
          [customerId] : false,
        },
        loadingAddBRDomainProvidedError: {
          ...state.loadingAddBRDomainProvidedError,
          [customerId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewDomainProvided: false
        },
      }
    }

      /***********************************
       * UPDATE_BR_DOMAIN_PROVIDED Archive delete provided domains
       ***********************************/

    case UPDATE_BR_DOMAIN_PROVIDED: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingUpdateBRDomainProvided: {
          ...state.loadingUpdateBRDomainProvided,
          [customerId] : true,
        },
        loadingUpdateBRDomainProvidedError: {
          ...state.loadingUpdateBRDomainProvidedError,
          [customerId] : false,
        },

      }
    }

    case UPDATE_BR_DOMAIN_PROVIDED_SUCCESS: {

      //result will be a new record to delete to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const entityId = action.payload.entityId
      const updatedBRDomainProvided = action.payload.inboundData

      // console.log("BR_PORTFOLIO_ENTITY_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRBusinessSharesData, "for these entities", entities, "for this entityId", entityId);

      //TODO: keep an eye on this now it has been updated for portfolio

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfTargetIPProvidedData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPTargetIPProvidedData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      const dataStateLocation = isSelfTargetIPProvidedData
          ? customerStateLocation.self.domains
              ? customerStateLocation.self.domains
              : {}
          : isBRPTargetIPProvidedData
              ? customerStateLocation.entities[entityId].domains
                  ? customerStateLocation.entities[entityId].domains
                  : {}
              : null

      console.log("UPDATE_BR_DOMAIN_PROVIDED_SUCCESS", "isSelfTargetIPProvidedData", isSelfTargetIPProvidedData, "isBRPTargetIPProvidedData", isBRPTargetIPProvidedData, "dataStateLocation is", dataStateLocation);


      //TODO: keep an eye on this now it has been updated for portfolio

      // return {
      //   ...state,
      //   portfolios: {
      //     ...state.portfolios,
      //     [customerId] : {
      //       ...state.portfolios[customerId],
      //       self: {
      //         ...state.portfolios[customerId].self,
      //         // [entityId]: {
      //         //   ...state.portfolios[customerId].entities[entityId],
      //         domains: {
      //           ...state.portfolios[customerId].self.domains,
      //           [updatedBRDomainProvided.id]: updatedBRDomainProvided
      //         }
      //         // }
      //       }
      //     }
      //   },
      //
      //   loadingUpdateBRDomainProvided: {
      //     ...state.loadingUpdateBRDomainProvided,
      //     [customerId] : false,
      //   },
      //   loadingUpdateBRDomainProvidedError: {
      //     ...state.loadingUpdateBRDomainProvidedError,
      //     [customerId] : false,
      //   },
      //
      // }

      if (isSelfTargetIPProvidedData) {
        const newIsSelfTechData =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                // [entityId]: {
                //   ...state.portfolios[customerId].self[entityId],
                domains: {
                  ...state.portfolios[customerId].self.domains,
                  [updatedBRDomainProvided.id]: updatedBRDomainProvided
                }
              }
              // }
            }
          },

          loadingUpdateBRDomainProvided: {
            ...state.loadingUpdateBRDomainProvided,
            [customerId] : false,
          },
          loadingUpdateBRDomainProvidedError: {
            ...state.loadingUpdateBRDomainProvidedError,
            [customerId] : false,
          },
        }

        console.log("New state for newIsSelfTechData will be", newIsSelfTechData, "returning now");
        return newIsSelfTechData;
      } else if(isBRPTargetIPProvidedData) {
        const newIsBRPTechDataState =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                  domains: {
                    ...state.portfolios[customerId].entities[entityId].domains,
                    [updatedBRDomainProvided.id]: updatedBRDomainProvided
                  }
                }
              }
            }
          },

          loadingUpdateBRDomainProvided: {
            ...state.loadingUpdateBRDomainProvided,
            [customerId] : false,
          },
          loadingUpdateBRDomainProvidedError: {
            ...state.loadingUpdateBRDomainProvidedError,
            [customerId] : false,
          },
        }

        console.log("New newIsBRPTechDataState will be", newIsBRPTechDataState, "Returning to state handler", "state.portfolios[customerId].entities[entityId]", state.portfolios[customerId].entities[entityId]);
        return newIsBRPTechDataState;

      } else { //some sort of problem happened.
        console.warn("Cannot update state with updated provided domain details. Error knowing where to put the data");
        return {
          ...state,

          loadingUpdateBRDomainProvided: {
            ...state.loadingUpdateBRDomainProvided,
            [customerId] : false,
          },
          loadingUpdateBRDomainProvidedError: {
            ...state.loadingUpdateBRDomainProvidedError,
            [customerId] : false,
          },
        }
      }
    }

    case UPDATE_BR_DOMAIN_PROVIDED_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingUpdateBRDomainProvided: {
          ...state.loadingUpdateBRDomainProvided,
          [customerId] : false,
        },
        loadingUpdateBRDomainProvidedError: {
          ...state.loadingUpdateBRDomainProvidedError,
          [customerId] : true,
        },

      }
    }

      /***********************************
       * ADD_BR_SUBDOMAIN_PROVIDED
       ***********************************/

    case ADD_BR_SUBDOMAIN_PROVIDED: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRSubdomainProvided: {
          ...state.loadingAddBRSubdomainProvided,
          [customerId] : true,
        },
        loadingAddBRSubdomainProvidedError: {
          ...state.loadingAddBRSubdomainProvidedError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewSubdomainProvided: null
        },
      }
    }

    case ADD_BR_SUBDOMAIN_PROVIDED_SUCCESS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const entityId = action.payload.entityId
      const newBRSubdomainProvidedData = action.payload.inboundData

      // console.log("ADD_BR_SUBDOMAIN_PROVIDED_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRSubdomainProvidedsData, "for these entities", entities, "for this entityId", entityId);

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfTargetIPProvidedData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPTargetIPProvidedData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      const dataStateLocation = isSelfTargetIPProvidedData
          ? customerStateLocation.self.subdomains_provided
              ? customerStateLocation.self.subdomains_provided
              : {}
          : isBRPTargetIPProvidedData
              ? customerStateLocation.entities[entityId].subdomains_provided
                  ? customerStateLocation.entities[entityId].subdomains_provided
                  : {}
              : null

      console.log("ADD_BR_SUBDOMAIN_PROVIDED_SUCCESS", "isSelfTargetIPProvidedData", isSelfTargetIPProvidedData, "isBRPTargetIPProvidedData", isBRPTargetIPProvidedData, "dataStateLocation is", dataStateLocation);


      //TODO: keep an eye on this now it has been updated for portfolio

      // return {
      //   ...state,
      //   portfolios: {
      //     ...state.portfolios,
      //     [customerId] : {
      //       ...state.portfolios[customerId],
      //       self: {
      //         ...state.portfolios[customerId].self,
      //         // [entityId]: {
      //         //   ...state.portfolios[customerId].entities[entityId],
      //         subdomains_provided: {
      //           ...state.portfolios[customerId].self.subdomains_provided,
      //           [newBRSubdomainProvidedData.id]: newBRSubdomainProvidedData
      //         }
      //         // }
      //       }
      //     }
      //   },
      //
      //   loadingAddBRSubdomainProvided: {
      //     ...state.loadingAddBRSubdomainProvided,
      //     [customerId] : false,
      //   },
      //   loadingAddBRSubdomainProvidedError: {
      //     ...state.loadingAddBRSubdomainProvidedError,
      //     [customerId] : false,
      //   },
      //   appMisc: {
      //     ...state.appMisc,
      //     didJustCreateNewSubdomainProvided: true
      //   },
      // }

      if (isSelfTargetIPProvidedData) {
        const newIsSelfTechData =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                // [entityId]: {
                //   ...state.portfolios[customerId].self[entityId],
                subdomains_provided: {
                  ...state.portfolios[customerId].self.subdomains_provided,
                  [newBRSubdomainProvidedData.id]: newBRSubdomainProvidedData
                }
              }
              // }
            }
          },

          loadingAddBRSubdomainProvided: {
            ...state.loadingAddBRSubdomainProvided,
            [customerId] : false,
          },
          loadingAddBRSubdomainProvidedError: {
            ...state.loadingAddBRSubdomainProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewSubdomainProvided: true
          },
        }

        console.log("New state for newIsSelfTechData will be", newIsSelfTechData, "returning now");
        return newIsSelfTechData;
      } else if(isBRPTargetIPProvidedData) {
        const newIsBRPTechDataState =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                  subdomains_provided: {
                    ...state.portfolios[customerId].entities[entityId].subdomains_provided,
                    [newBRSubdomainProvidedData.id]: newBRSubdomainProvidedData
                  }
                }
              }
            }
          },

          loadingAddBRSubdomainProvided: {
            ...state.loadingAddBRSubdomainProvided,
            [customerId] : false,
          },
          loadingAddBRSubdomainProvidedError: {
            ...state.loadingAddBRSubdomainProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewSubdomainProvided: true
          },
        }

        console.log("New newIsBRPTechDataState will be", newIsBRPTechDataState, "Returning to state handler", "state.portfolios[customerId].entities[entityId]", state.portfolios[customerId].entities[entityId]);
        return newIsBRPTechDataState;

      } else { //some sort of problem happened.
        console.warn("Cannot update state with added provided subdomain details. Error knowing where to put the data");
        return {
          ...state,

          loadingAddBRSubdomainProvided: {
            ...state.loadingAddBRSubdomainProvided,
            [customerId] : false,
          },
          loadingAddBRSubdomainProvidedError: {
            ...state.loadingAddBRSubdomainProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewSubdomainProvided: true
          },
        }
      }
    }

    case ADD_BR_SUBDOMAIN_PROVIDED_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRSubdomainProvided: {
          ...state.loadingAddBRSubdomainProvided,
          [customerId] : false,
        },
        loadingAddBRSubdomainProvidedError: {
          ...state.loadingAddBRSubdomainProvidedError,
          [customerId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewSubdomainProvided: false
        },
      }
    }

      /***********************************
       * UPDATE_BR_SUBDOMAIN_PROVIDED Archive delete provided domains
       ***********************************/

    case UPDATE_BR_SUBDOMAIN_PROVIDED: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingUpdateBRSubdomainProvided: {
          ...state.loadingUpdateBRSubdomainProvided,
          [customerId] : true,
        },
        loadingUpdateBRSubdomainProvidedError: {
          ...state.loadingUpdateBRSubdomainProvidedError,
          [customerId] : false,
        },

      }
    }

    case UPDATE_BR_SUBDOMAIN_PROVIDED_SUCCESS: {

      //result will be a new record to delete to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const entityId = action.payload.entityId
      const updatedBRSubdomainProvidedData = action.payload.inboundData

      // console.log("BR_PORTFOLIO_ENTITY_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRBusinessSharesData, "for these entities", entities, "for this entityId", entityId);

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfTargetIPProvidedData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPTargetIPProvidedData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      const dataStateLocation = isSelfTargetIPProvidedData
          ? customerStateLocation.self.subdomains_provided
              ? customerStateLocation.self.subdomains_provided
              : {}
          : isBRPTargetIPProvidedData
              ? customerStateLocation.entities[entityId].subdomains_provided
                  ? customerStateLocation.entities[entityId].subdomains_provided
                  : {}
              : null

      console.log("UPDATE_BR_SUBDOMAIN_PROVIDED_SUCCESS", "isSelfTargetIPProvidedData", isSelfTargetIPProvidedData, "isBRPTargetIPProvidedData", isBRPTargetIPProvidedData, "dataStateLocation is", dataStateLocation);


      //TODO: keep an eye on this now it has been updated for portfolio

      // return {
      //   ...state,
      //   portfolios: {
      //     ...state.portfolios,
      //     [customerId] : {
      //       ...state.portfolios[customerId],
      //       self: {
      //         ...state.portfolios[customerId].self,
      //         // [entityId]: {
      //         //   ...state.portfolios[customerId].entities[entityId],
      //         subdomains_provided: {
      //           ...state.portfolios[customerId].self.subdomains_provided,
      //           [updatedBRSubdomainProvidedData.id]: updatedBRSubdomainProvidedData
      //         }
      //         // }
      //       }
      //     }
      //   },
      //
      //   loadingUpdateBRSubdomainProvided: {
      //     ...state.loadingUpdateBRSubdomainProvided,
      //     [customerId] : false,
      //   },
      //   loadingUpdateBRSubdomainProvidedError: {
      //     ...state.loadingUpdateBRSubdomainProvidedError,
      //     [customerId] : false,
      //   },
      //
      // }

      if (isSelfTargetIPProvidedData) {
        const newIsSelfTechData =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                // [entityId]: {
                //   ...state.portfolios[customerId].self[entityId],
                subdomains_provided: {
                  ...state.portfolios[customerId].self.subdomains_provided,
                  [updatedBRSubdomainProvidedData.id]: updatedBRSubdomainProvidedData
                }
              }
              // }
            }
          },

          loadingUpdateBRSubdomainProvided: {
            ...state.loadingUpdateBRSubdomainProvided,
            [customerId] : false,
          },
          loadingUpdateBRSubdomainProvidedError: {
            ...state.loadingUpdateBRSubdomainProvidedError,
            [customerId] : false,
          },
        }

        console.log("New state for newIsSelfTechData will be", newIsSelfTechData, "returning now");
        return newIsSelfTechData;
      } else if(isBRPTargetIPProvidedData) {
        const newIsBRPTechDataState =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                  subdomains_provided: {
                    ...state.portfolios[customerId].entities[entityId].subdomains_provided,
                    [updatedBRSubdomainProvidedData.id]: updatedBRSubdomainProvidedData
                  }
                }
              }
            }
          },

          loadingUpdateBRSubdomainProvided: {
            ...state.loadingUpdateBRSubdomainProvided,
            [customerId] : false,
          },
          loadingUpdateBRSubdomainProvidedError: {
            ...state.loadingUpdateBRSubdomainProvidedError,
            [customerId] : false,
          },
        }

        console.log("New newIsBRPTechDataState will be", newIsBRPTechDataState, "Returning to state handler", "state.portfolios[customerId].entities[entityId]", state.portfolios[customerId].entities[entityId]);
        return newIsBRPTechDataState;

      } else { //some sort of problem happened.
        console.warn("Cannot update state with updating provided subdomain details. Error knowing where to put the data");
        return {
          ...state,

          loadingUpdateBRSubdomainProvided: {
            ...state.loadingUpdateBRSubdomainProvided,
            [customerId] : false,
          },
          loadingUpdateBRSubdomainProvidedError: {
            ...state.loadingUpdateBRSubdomainProvidedError,
            [customerId] : false,
          },
        }
      }
    }

    case UPDATE_BR_SUBDOMAIN_PROVIDED_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingUpdateBRSubdomainProvided: {
          ...state.loadingUpdateBRSubdomainProvided,
          [customerId] : false,
        },
        loadingUpdateBRSubdomainProvidedError: {
          ...state.loadingUpdateBRSubdomainProvidedError,
          [customerId] : true,
        },

      }
    }
      /***********************************
       * ADD_BR_IDENTITY_PROVIDED
       ***********************************/

    case ADD_BR_IDENTITY_PROVIDED: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRIdentityProvided: {
          ...state.loadingAddBRIdentityProvided,
          [customerId] : true,
        },
        loadingAddBRIdentityProvidedError: {
          ...state.loadingAddBRIdentityProvidedError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewIdentityProvided: null
        },
      }
    }

    case ADD_BR_IDENTITY_PROVIDED_SUCCESS: {

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const entityId = action.payload.entityId
      const newBRIdentityProvidedData = action.payload.inboundData

      console.log("ADD_BR_IDENTITY_PROVIDED_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRIdentityProvidedData, "for this entityId", entityId,
          "to be put here", state.portfolios[customerId].self.identities_provided);


      //TODO: keep an eye on this now it has been updated for portfolio

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfTargetIPProvidedData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPTargetIPProvidedData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      const dataStateLocation = isSelfTargetIPProvidedData
          ? customerStateLocation.self.identities_provided
              ? customerStateLocation.self.identities_provided
              : {}
          : isBRPTargetIPProvidedData
              ? customerStateLocation.entities[entityId].identities_provided
                  ? customerStateLocation.entities[entityId].identities_provided
                  : {}
              : null

      console.log("ADD_BR_IDENTITY_PROVIDED_SUCCESS", "isSelfTargetIPProvidedData", isSelfTargetIPProvidedData, "isBRPTargetIPProvidedData", isBRPTargetIPProvidedData, "dataStateLocation is", dataStateLocation);


      //TODO: keep an eye on this now it has been updated for portfolio

      // return {
      //   ...state,
      //   portfolios: {
      //     ...state.portfolios,
      //     [customerId] : {
      //       ...state.portfolios[customerId],
      //       self: {
      //         ...state.portfolios[customerId].self,
      //         // [entityId]: {
      //         //   ...state.portfolios[customerId].self[entityId],
      //         identities_provided: {
      //           ...state.portfolios[customerId].self.identities_provided,
      //           [newBRIdentityProvidedData.id]: newBRIdentityProvidedData
      //         }
      //       }
      //       // }
      //     }
      //   },
      //
      //   loadingAddBRIdentityProvided: {
      //     ...state.loadingAddBRIdentityProvided,
      //     [customerId] : false,
      //   },
      //   loadingAddBRIdentityProvidedError: {
      //     ...state.loadingAddBRIdentityProvidedError,
      //     [customerId] : false,
      //   },
      //   appMisc: {
      //     ...state.appMisc,
      //     didJustCreateNewIdentityProvided: true
      //   },
      // }

      if (isSelfTargetIPProvidedData) {
        const newIsSelfTechData =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                // [entityId]: {
                //   ...state.portfolios[customerId].self[entityId],
                identities_provided: {
                  ...state.portfolios[customerId].self.identities_provided,
                  [newBRIdentityProvidedData.id]: newBRIdentityProvidedData
                }
              }
              // }
            }
          },

          loadingAddBRIdentityProvided: {
            ...state.loadingAddBRIdentityProvided,
            [customerId] : false,
          },
          loadingAddBRIdentityProvidedError: {
            ...state.loadingAddBRIdentityProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewIdentityProvided: true
          },
        }

        console.log("New state for newIsSelfTechData will be", newIsSelfTechData, "returning now");
        return newIsSelfTechData;
      } else if(isBRPTargetIPProvidedData) {
        const newIsBRPTechDataState =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                  identities_provided: {
                    ...state.portfolios[customerId].entities[entityId].identities_provided,
                    [newBRIdentityProvidedData.id]: newBRIdentityProvidedData
                  }
                }
              }
            }
          },

          loadingAddBRIdentityProvided: {
            ...state.loadingAddBRIdentityProvided,
            [customerId] : false,
          },
          loadingAddBRIdentityProvidedError: {
            ...state.loadingAddBRIdentityProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewIdentityProvided: true
          },
        }

        console.log("New newIsBRPTechDataState will be", newIsBRPTechDataState, "Returning to state handler", "state.portfolios[customerId].entities[entityId]", state.portfolios[customerId].entities[entityId]);
        return newIsBRPTechDataState;

      } else { //some sort of problem happened.
        console.warn("Cannot update state with adding a provided identity. Error knowing where to put the data");
        return {
          ...state,

          loadingAddBRIdentityProvided: {
            ...state.loadingAddBRIdentityProvided,
            [customerId] : false,
          },
          loadingAddBRIdentityProvidedError: {
            ...state.loadingAddBRIdentityProvidedError,
            [customerId] : false,
          },
          appMisc: {
            ...state.appMisc,
            didJustCreateNewIdentityProvided: true
          },
        }
      }
    }

    case ADD_BR_IDENTITY_PROVIDED_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRIdentityProvided: {
          ...state.loadingAddBRIdentityProvided,
          [customerId] : false,
        },
        loadingAddBRIdentityProvidedError: {
          ...state.loadingAddBRIdentityProvidedError,
          [customerId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewIdentityProvided: false
        },
      }
    }
      /***********************************
       * UPDATE_BR_IDENTITY_PROVIDED
       ***********************************/

    case UPDATE_BR_IDENTITY_PROVIDED: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingUpdateBRIdentityProvided: {
          ...state.loadingUpdateBRIdentityProvided,
          [customerId] : true,
        },
        loadingAddBRIdentityProvidedError: {
          ...state.loadingUpdateBRIdentityProvidedError,
          [customerId] : false,
        },
      }
    }

    case UPDATE_BR_IDENTITY_PROVIDED_SUCCESS: {

      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const entityId = action.payload.entityId
      const newBRIdentityProvidedData = action.payload.inboundData

      console.log("UPDATE_BR_IDENTITY_PROVIDED_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRIdentityProvidedData, "for this entityId", entityId);



      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfTargetIPProvidedData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPTargetIPProvidedData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      const dataStateLocation = isSelfTargetIPProvidedData
          ? customerStateLocation.self.identities_provided
              ? customerStateLocation.self.identities_provided
              : {}
          : isBRPTargetIPProvidedData
              ? customerStateLocation.entities[entityId].identities_provided
                  ? customerStateLocation.entities[entityId].identities_provided
                  : {}
              : null

      console.log("UPDATE_BR_IDENTITY_PROVIDED_SUCCESS", "isSelfTargetIPProvidedData", isSelfTargetIPProvidedData, "isBRPTargetIPProvidedData", isBRPTargetIPProvidedData, "dataStateLocation is", dataStateLocation);


      //TODO: keep an eye on this now it has been updated for portfolio

      // return {
      //   ...state,
      //   portfolios: {
      //     ...state.portfolios,
      //     [customerId] : {
      //       ...state.portfolios[customerId],
      //       self: {
      //         ...state.portfolios[customerId].self,
      //         identities_provided: {
      //           ...state.portfolios[customerId].self.identities_provided,
      //           [newBRIdentityProvidedData.id]: newBRIdentityProvidedData
      //         }
      //       }
      //     }
      //   },
      //
      //   loadingUpdateBRIdentityProvided: {
      //     ...state.loadingUpdateBRIdentityProvided,
      //     [customerId] : false,
      //   },
      //   loadingUpdateBRIdentityProvidedError: {
      //     ...state.loadingUpdateBRIdentityProvidedError,
      //     [customerId] : false,
      //   },
      // }

      if (isSelfTargetIPProvidedData) {
        const newIsSelfTechData =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                // [entityId]: {
                //   ...state.portfolios[customerId].self[entityId],
                identities_provided: {
                  ...state.portfolios[customerId].self.identities_provided,
                  [newBRIdentityProvidedData.id]: newBRIdentityProvidedData
                }
              }
              // }
            }
          },

          loadingUpdateBRIdentityProvided: {
            ...state.loadingUpdateBRIdentityProvided,
            [customerId] : false,
          },
          loadingUpdateBRIdentityProvidedError: {
            ...state.loadingUpdateBRIdentityProvidedError,
            [customerId] : false,
          },
        }

        console.log("New state for newIsSelfTechData will be", newIsSelfTechData, "returning now");
        return newIsSelfTechData;
      } else if(isBRPTargetIPProvidedData) {
        const newIsBRPTechDataState =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                  identities_provided: {
                    ...state.portfolios[customerId].entities[entityId].identities_provided,
                    [newBRIdentityProvidedData.id]: newBRIdentityProvidedData
                  }
                }
              }
            }
          },

          loadingUpdateBRIdentityProvided: {
            ...state.loadingUpdateBRIdentityProvided,
            [customerId] : false,
          },
          loadingUpdateBRIdentityProvidedError: {
            ...state.loadingUpdateBRIdentityProvidedError,
            [customerId] : false,
          },
        }

        console.log("New newIsBRPTechDataState will be", newIsBRPTechDataState, "Returning to state handler", "state.portfolios[customerId].entities[entityId]", state.portfolios[customerId].entities[entityId]);
        return newIsBRPTechDataState;

      } else { //some sort of problem happened.
        console.warn("Cannot update state with updating a provided identity. Error knowing where to put the data");
        return {
          ...state,

          loadingUpdateBRIdentityProvided: {
            ...state.loadingUpdateBRIdentityProvided,
            [customerId] : false,
          },
          loadingUpdateBRIdentityProvidedError: {
            ...state.loadingUpdateBRIdentityProvidedError,
            [customerId] : false,
          },
        }
      }

    }

    case UPDATE_BR_IDENTITY_PROVIDED_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingUpdateBRIdentityProvided: {
          ...state.loadingUpdateBRIdentityProvided,
          [customerId] : false,
        },
        loadingUpdateBRIdentityProvidedError: {
          ...state.loadingUpdateBRIdentityProvidedError,
          [customerId] : true,
        },
      }
    }

      /***********************************
       * ADD_BR_VALIDATION
       ***********************************/

    case ADD_BR_VALIDATION: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRValidation: {
          ...state.loadingAddBRValidation,
          [customerId] : true,
        },
        loadingAddBRValidationError: {
          ...state.loadingAddBRValidationError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewValidation: null
        },
      }
    }

    case ADD_BR_VALIDATION_SUCCESS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      // const entityId = action.payload.entityId
      const newBRValidationData = action.payload.inboundData

      // console.log("ADD_BR_VALIDATION_SUCCESS reducer about to put new business shares into the state. Here are the shares", newBRValidationsData, "for these entities", entities, "for this entityId", entityId);

      return {
        ...state,
        portfolios: {
          ...state.portfolios,
          [customerId] : {
            ...state.portfolios[customerId],
            self: {
              ...state.portfolios[customerId].self,
              // [entityId]: {
              //   ...state.portfolios[customerId].entities[entityId],
                validation: {
                  ...state.portfolios[customerId].self.validation,
                  [newBRValidationData.id]: newBRValidationData
                }
              // }
            }
          }
        },

        loadingAddBRValidation: {
          ...state.loadingAddBRValidation,
          [customerId] : false,
        },
        loadingAddBRValidationError: {
          ...state.loadingAddBRValidationError,
          [customerId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewValidation: true,
          didJustAddEntityTag: {
            ...state.appMisc.didJustAddEntityTag,
            [customerId] : true
          }
        },
      }
    }

    case ADD_BR_VALIDATION_FAIL: {
      const customerId = action.payload.customerId
      return {
        ...state,
        loadingAddBRValidation: {
          ...state.loadingAddBRValidation,
          [customerId] : false,
        },
        loadingAddBRValidationError: {
          ...state.loadingAddBRValidationError,
          [customerId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustCreateNewValidation: false
        },
      }
    }


      /***********************************
       * FETCH_CYCLE_TARGETS
       ***********************************/

    case FETCH_CYCLE_TARGETS: {
      const cycleId = action.payload.cycleId
      const pageNum = action.payload.pageNum;
      return {
        ...state,
        loadingCycleTargets: {
          ...state.loadingCycleTargets,
          [cycleId] : {
            page: pageNum
          },
        },
        loadingCycleTargetsError: {
          ...state.loadingCycleTargetsError,
          [cycleId] : false,
        },
      }
    }

    case FETCH_CYCLE_TARGETS_SUCCESS: {

      // const entities = state.portfolios && state.portfolios[action.payload.customerId] ? state.portfolios[action.payload.customerId].entities : null;
      // const entityId = action.payload && action.payload.inboundData ? action.payload.inboundData.entity : null;
      const customerId = action.payload.customerId
      const assumedEntityId = action.payload.assumedEntityId //this is the entity that has been passed around the app, fallback value
      const cycleId = action.payload.cycleId
      const entireInboundData = action.payload.inboundData
      const newTargetMeta = action.payload.inboundData.totals
          ? action.payload.inboundData.totals
          : null

      const newCycleTargetsData = action.payload.inboundData.targets
          ? action.payload.inboundData.targets
          : []
      const pageNum = action.payload.pageNum;
      const totalPages = newTargetMeta && newTargetMeta.pages;

      const entityId = newCycleTargetsData.entity
          ?  newCycleTargetsData.entity
          : assumedEntityId
              ? assumedEntityId
              : null;
      // const totals = newCycleTargetsData ?  newCycleTargetsData.totals : null;

      const loadingCycleTargetsObject = pageNum !== totalPages
        ? {page: pageNum,
          nextPageRequest: pageNum + 1,
          total: totalPages}
          : false;

      if(entityId !== assumedEntityId) {
        console.warn("FETCH_CYCLE_TARGETS_SUCCESS The entityId recieved from the API is different than the one tracking internally. Data may be placed in the wrong spot.")
      }

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfTargetData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId
          && customerStateLocation.self.cycles //if this is a self entity
          && cycleId
          && customerStateLocation.self.cycles[cycleId])

      const isBRPTargetData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId]
          && customerStateLocation.entities[entityId].cycles
          && cycleId
          && customerStateLocation.entities[entityId].cycles[cycleId])

      const targetDataStateLocation = isSelfTargetData
          ? customerStateLocation.self.cycles[cycleId].targets
              ? customerStateLocation.self.cycles[cycleId].targets
              : []
          : isBRPTargetData
              ? customerStateLocation.entities[entityId].cycles[cycleId].targets
                  ? customerStateLocation.entities[entityId].cycles[cycleId].targets
                  : []
              : null

      console.log("FETCH_CYCLE_TARGETS_SUCCESS initial checks to determine where this target data should go.", "customerId", customerId, "cycleId", cycleId, "customerStateLocation", customerStateLocation, "isSelfTargetData",  isSelfTargetData,"entireInboundData", entireInboundData, "isBRPTargetData", isBRPTargetData, "targetDataStateLocation is", targetDataStateLocation, "Using this newCycleTargetsData", newCycleTargetsData, "assumedEntityId", assumedEntityId, "entityId", entityId, "newTargetMeta", newTargetMeta);



      const oldTargets = Array.isArray(targetDataStateLocation)
          ? targetDataStateLocation : [];
      const newPlusOldTargets = oldTargets.concat(newCycleTargetsData);

      //removing this search bit until that's more fleshed out
      // const targetsSearchArray = [];
      //
      // const targetsWithTagsArray = newPlusOldTargets
      //     .filter((target)=> target && target.Tags && Object.values(target.Tags).length > 0)
      //
      //     targetsWithTagsArray.forEach((target)=>{
      //       target
      //       && target.Tags
      //       && Object.values(target.Tags).forEach((tag)=> {
      //         if((tag && tag.definition && tag.definition.name) && SearchableValues[tag.definition.name] && SearchableValues[tag.definition.name].array){
      //           SearchableValues[tag.definition.name].array.push(
      //               {
      //                 id: target.Id,
      //                 techType: tag && tag.definition && tag.definition.name,
      //                 cycleId: cycleId,
      //                 entityId: entityId,
      //                 customerId: customerId,
      //               })
      //         }
      //       })});


      // const existingTargetsSearchArray = state.searchEntities && state.searchEntities.techTypes
      //     ? state.searchEntities.techTypes
      //     : [];

      const oldTargetMeta = state.portfolios
      && state.portfolios[customerId]
      && state.portfolios[customerId].self
      && state.portfolios[customerId].self.cycles
      && state.portfolios[customerId].self.cycles[cycleId]
      && state.portfolios[customerId].self.cycles[cycleId].targetMeta
          ? state.portfolios[customerId].self.cycles[cycleId].targetMeta
          : {};

      console.log("FETCH_CYCLE_TARGETS_SUCCESS reducer state tree is ", state, "about to insert", newCycleTargetsData, "oldTargets", oldTargets, "newPlusOldTargets", newPlusOldTargets, "and new meta", newTargetMeta, "payload", action.payload, "loading object to set is", loadingCycleTargetsObject)

      //This is the original return statement before Foster trying to fix the portfolio targets fetching
      // return {
      //   ...state,
      //   portfolios: {
      //     ...state.portfolios,
      //     [customerId] : {
      //       ...state.portfolios[customerId],
      //       self: {
      //         ...state.portfolios[customerId].self,
      //
      //         cycles: {
      //           ...state.portfolios[customerId].self.cycles,
      //           [cycleId]: {
      //             ///FOSTER NOTE: I THINK I NEED TO REMOVE THE FOLLOWING LINE FOR CASES WHERE THERE IS NO CYCLE ID
      //             // (trusted agent use case)
      //             ...state.portfolios[customerId].self.cycles[cycleId],
      //             targets: newTargets,
      //             //not all calls return the meta. If this call did, update it.
      //             targetMeta: newTargetMeta ? newTargetMeta : oldTargetMeta,
      //           }
      //         }
      //
      //       }
      //     }
      //   },
      //
      //   loadingCycleTargets: {
      //     ...state.loadingCycleTargets,
      //     [cycleId] : false,
      //   },
      //   loadingCycleTargetsError: {
      //     ...state.loadingCycleTargetsError,
      //     [cycleId] : false,
      //   },
      // }

      if (isSelfTargetData) {
        const newIsSelfTargetData =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,

                cycles: {
                  ...state.portfolios[customerId].self.cycles,
                  [cycleId]: {
                    ///FOSTER NOTE: I THINK I NEED TO REMOVE THE FOLLOWING LINE FOR CASES WHERE THERE IS NO CYCLE ID
                    // (trusted agent use case)
                    ...state.portfolios[customerId].self.cycles[cycleId],
                    targets: newPlusOldTargets,
                    //not all calls return the meta. If this call did, update it.
                    targetMeta: newTargetMeta ? newTargetMeta : oldTargetMeta,
                  }
                }

              }
            }
          },

          loadingCycleTargets: {
            ...state.loadingCycleTargets,
            [cycleId] : loadingCycleTargetsObject,
          },
          loadingCycleTargetsError: {
            ...state.loadingCycleTargetsError,
            [cycleId] : false,
          },
          // searchEntities: {
          //   ...state.searchEntities,
          //   techTypes: existingTargetsSearchArray.concat(targetsSearchArray),
          // }
        }

        console.log("FETCH_CYCLE_TARGETS_SUCCESS New state for newIsSelfTargetData will be", newIsSelfTargetData, "returning now");
        return newIsSelfTargetData;
      } else if(isBRPTargetData) {
        const newIsBRPTargetDataState =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                  cycles: {
                    ...state.portfolios[customerId].entities[entityId].cycles,
                    [cycleId]: {
                      ...state.portfolios[customerId].entities[entityId].cycles[cycleId],
                      targets: newPlusOldTargets,
                      //not all calls return the meta. If this call did, update it.
                      targetMeta: newTargetMeta ? newTargetMeta : oldTargetMeta,
                    }
                  }
                }
              }
            }
          },

          loadingCycleTargets: {
            ...state.loadingCycleTargets,
            [cycleId] : loadingCycleTargetsObject,
          },
          loadingCycleTargetsError: {
            ...state.loadingCycleTargetsError,
            [cycleId] : false,
          },
          // searchEntities: {
          //   ...state.searchEntities,
          //   techTypes: existingTargetsSearchArray.concat(targetsSearchArray),
          // }
        }

        console.log("FETCH_CYCLE_TARGETS_SUCCESS New newIsBRPTargetDataState will be", newIsBRPTargetDataState, "Returning to state handler", "state.portfolios[customerId].entities[entityId].cycles[cycleId]", state.portfolios[customerId].entities[entityId].cycles[cycleId]);
        return newIsBRPTargetDataState;

      } else { //some sort of problem happened.
        console.warn("FETCH_CYCLE_TARGETS_SUCCESS Cannot update state with target details. Error knowing where to put the data");
        return {
          ...state,

          loadingCycleTargets: {
            ...state.loadingCycleTargets,
            [cycleId] : false,
          },
          loadingCycleTargetsError: {
            ...state.loadingCycleTargetsError,
            [cycleId] : false,
          },
        }
      }
    }

    case FETCH_CYCLE_TARGETS_FAIL: {
      const cycleId = action.payload.cycleId
      const pageNum = action.payload.pageNum
      return {
        ...state,
        loadingCycleTargets: {
          ...state.loadingCycleTargets,
          [cycleId] : {
            page: pageNum,
            nextPageRequest: pageNum,
          },
        },
        loadingCycleTargetsError: {
          ...state.loadingCycleTargetsError,
          [cycleId] : true,
        },
      }
    }

      /***********************************
       * FETCH_TARGET_Details
       ***********************************/

    case FETCH_TARGET_DETAILS: {
      const targetId = action.payload.targetId
      return {
        ...state,
        loadingTargetDetails: {
          ...state.loadingTargetDetails,
          [targetId] : true,
        },
        loadingTargetDetailsError: {
          ...state.loadingTargetDetailsError,
          [targetId] : false,
        },
      }
    }

    case FETCH_TARGET_DETAILS_SUCCESS: {

      const customerId = action.payload.customerId
      const entityId = action.payload.entityId
      const targetId = action.payload.targetId

      const newTargetDetailsData = action.payload && action.payload.inboundData ? action.payload.inboundData : null;
      const cycleId = newTargetDetailsData ? newTargetDetailsData.cycle : null

      // console.log("FETCH_TARGET_DETAILS_SUCCESS targetDetailsArray is", targetDetailsArray, "from state.portfolios", state.portfolios, "and customerId", customerId, "and cycleId", cycleId);

      // console.log("FETCH_TARGET_DETAILS_SUCCESS here's what we got back", action.payload)

      // console.log("This should be the target ID", targetId, action.payload.targetId)

      // console.log("somethign is happening with the index", indexOfOldTargetObject, oldTarget)

      // console.log("here's the information we are trying to find and alter", targetDetailsArray, "udpated target look slike", updatedTarget)


      //TODO: make this work for portfolio case

      // const targetDetailsArray =  state.portfolios
      // && state.portfolios[customerId]
      // && state.portfolios[customerId].self
      // && state.portfolios[customerId].self.cycles
      // && state.portfolios[customerId].self.cycles[cycleId]
      // && state.portfolios[customerId].self.cycles[cycleId].targets
      //     ? state.portfolios[customerId].self.cycles[cycleId].targets
      //     : null;

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfTargetIPProvidedData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPTargetIPProvidedData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      const targetDetailsArray = isSelfTargetIPProvidedData
          ? customerStateLocation.self
            && customerStateLocation.self.cycles
            && customerStateLocation.self.cycles[cycleId]
            && customerStateLocation.self.cycles[cycleId].targets
              ? customerStateLocation.self.cycles[cycleId].targets
              : {}
          : isBRPTargetIPProvidedData
              ? customerStateLocation.entities
                && customerStateLocation.entities[entityId]
                && customerStateLocation.entities[entityId].cycles
                && customerStateLocation.entities[entityId].cycles[cycleId]
                && customerStateLocation.entities[entityId].cycles[cycleId].targets
                  ? customerStateLocation.entities[entityId].cycles[cycleId].targets
                  : {}
              : null


      const indexOfOldTargetObject = targetDetailsArray.findIndex(x => x.Id === targetId)

      const oldTarget = targetDetailsArray[indexOfOldTargetObject]
      const updatedTarget = {
        ...oldTarget,
        ...newTargetDetailsData,
      };

      targetDetailsArray[indexOfOldTargetObject] = updatedTarget;

      console.log("FETCH_TARGET_DETAILS_SUCCESS", "isSelfTargetIPProvidedData", isSelfTargetIPProvidedData, "isBRPTargetIPProvidedData", isBRPTargetIPProvidedData, "targetDetailsArray is", targetDetailsArray);


      //TODO: keep an eye on this now it has been updated for portfolio

      // return {
      //   ...state,
      //   portfolios: {
      //     ...state.portfolios,
      //     [customerId] : {
      //       ...state.portfolios[customerId],
      //       self: {
      //         ...state.portfolios[customerId].self,
      //         cycles: {
      //           ...state.portfolios[customerId].self.cycles,
      //           [cycleId]: {
      //             ...state.portfolios[customerId].self.cycles[cycleId],
      //             //targets is an array, not an object...
      //             targets: targetDetailsArray,
      //           }
      //         }
      //
      //       }
      //     }
      //   },
      //
      //   loadingTargetDetails: {
      //     ...state.loadingTargetDetails,
      //     [targetId] : false,
      //   },
      //   loadingTargetDetailsError: {
      //     ...state.loadingTargetDetailsError,
      //     [targetId] : false,
      //   },
      // }

      if (isSelfTargetIPProvidedData) {
        const newIsSelfTechData =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                cycles: {
                  ...state.portfolios[customerId].self.cycles,
                  [cycleId]: {
                    ...state.portfolios[customerId].self.cycles[cycleId],
                    //targets is an array, not an object...
                    targets: targetDetailsArray,
                  }
                }

              }
              // }
            }
          },

          loadingTargetDetails: {
            ...state.loadingTargetDetails,
            [targetId] : false,
          },
          loadingTargetDetailsError: {
            ...state.loadingTargetDetailsError,
            [targetId] : false,
          },
        }

        console.log("New state for newIsSelfTechData will be", newIsSelfTechData, "returning now");
        return newIsSelfTechData;
      } else if(isBRPTargetIPProvidedData) {
        const newIsBRPTechDataState =  {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                    cycles: {
                      ...state.portfolios[customerId].entities[entityId].cycles,
                      [cycleId]: {
                        ...state.portfolios[customerId].entities[entityId].cycles[cycleId],
                        //targets is an array, not an object...
                        targets: targetDetailsArray,
                      }
                    }
                }
              }
            }
          },

          loadingTargetDetails: {
            ...state.loadingTargetDetails,
            [targetId] : false,
          },
          loadingTargetDetailsError: {
            ...state.loadingTargetDetailsError,
            [targetId] : false,
          },
        }

        console.log("New newIsBRPTechDataState will be", newIsBRPTechDataState, "Returning to state handler", "state.portfolios[customerId].entities[entityId]", state.portfolios[customerId].entities[entityId]);
        return newIsBRPTechDataState;

      } else { //some sort of problem happened.
        console.warn("Cannot update state with target details. Error knowing where to put the data");
        return {
          ...state,

          loadingTargetDetails: {
            ...state.loadingTargetDetails,
            [targetId] : false,
          },
          loadingTargetDetailsError: {
            ...state.loadingTargetDetailsError,
            [targetId] : false,
          },
        }
      }

    }

    case FETCH_TARGET_DETAILS_FAIL: {
      console.log("fetch target details fail")
      const targetId = action.payload.targetId
      return {
        ...state,
        loadingTargetDetails: {
          ...state.loadingTargetDetails,
          [targetId] : false,
        },
        loadingTargetDetailsError: {
          ...state.loadingTargetDetailsError,
          [targetId] : true,
        },
      }
    }

    case ADD_TAG_SUCCESS_TESTED_VECTORS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset



      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const vectorId = action.payload.affectedElementId
      // const affectedElementId = action.payload.affectedElementId
      // const entityId = action.payload.entityId
      const newTagData = action.payload.inboundData
      const lastCycleId = state.portfolios[customerId].self.last_cycle.cycle

      const vectorArray =  state.portfolios[customerId].self.cycles[lastCycleId].techData.totals.vectors;
      const indexOfVectorToTag = vectorArray.findIndex(x => x.id === vectorId);
      const oldVector = vectorArray[indexOfVectorToTag]
      const updatedVector = {
        ...oldVector,
        tested_vector_details : {
          ...oldVector.tested_vector_details,
          tags: {
            ...oldVector.tested_vector_details.tags,
            [newTagData.id] : newTagData
          }
        }
      };

      vectorArray[indexOfVectorToTag] = updatedVector;

      console.log("Adding a new successful Tag to Local State tree.",customerId, vectorId, newTagData, lastCycleId);

      console.log("ADD_TAG_SUCCESS reducer about to update a vector", "oldVector", oldVector, "updatedVector", updatedVector);



      return {
        ...state,
        portfolios: {
          ...state.portfolios,
          [customerId] : {
            ...state.portfolios[customerId],
            self: {
              ...state.portfolios[customerId].self,
              cycles : {
                ...state.portfolios[customerId].self.cycles,
                [lastCycleId] : {
                  ...state.portfolios[customerId].self.cycles[lastCycleId],
                  techData: {
                    ...state.portfolios[customerId].self.cycles[lastCycleId].techData,
                    totals: {
                      ...state.portfolios[customerId].self.cycles[lastCycleId].techData.totals,
                      vectors: vectorArray
                      }


                  }
                }
              }
            }
          }
        },

        // loadingAddTag: {
        //   ...state.loadingAddTag,
        //   [affectedElementId] : false,
        // },
        // loadingAddTagError: {
        //   ...state.loadingAddTagError,
        //   [affectedElementId] : false,
        // },
      }
    }

    case ADD_TAG_FAIL_TESTED_VECTORS: {
      // const affectedElementId = action.payload.affectedElementId
      return {
        ...state,
        // loadingAddTag: {
        //   ...state.loadingAddTag,
        //   [affectedElementId] : false,
        // },
        // loadingAddTagError: {
        //   ...state.loadingAddTagError,
        //   [affectedElementId] : true,
        // },
      }
    }

    case UPDATE_TAG_SUCCESS_TESTED_VECTORS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset



      // const entities = state.portfolios[action.payload.customerId].entities
      // const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      const vectorId = action.payload.affectedElementId
      // const entityId = action.payload.entityId
      // const tagId = action.payload.tagId
      const newTagData = action.payload.inboundData
      const lastCycleId = state.portfolios[customerId].self.last_cycle.cycle

      const vectorArray =  state.portfolios[customerId].self.cycles[lastCycleId].techData.totals.vectors;
      const indexOfVectorToTag = vectorArray.findIndex(x => x.id === vectorId);
      const oldVector = vectorArray[indexOfVectorToTag]
      const updatedVector = {
        ...oldVector,
        tested_vector_details : {
          ...oldVector.tested_vector_details,
          tags: {
            ...oldVector.tested_vector_details.tags,
            [newTagData.id] : newTagData
          }
        }
      };

      vectorArray[indexOfVectorToTag] = updatedVector;

      // console.log("UPDATE_TAG_SUCCESS Updateing a new successful Tag to Local State tree.",customerId, vectorId, newTagData, lastCycleId);

      // console.log("UPDATE_TAG_SUCCESS reducer about to update a vector", "oldVector", oldVector, "updatedVector", updatedVector);

      return {
        ...state,
        portfolios: {
          ...state.portfolios,
          [customerId] : {
            ...state.portfolios[customerId],
            self: {
              ...state.portfolios[customerId].self,
              cycles : {
                ...state.portfolios[customerId].self.cycles,
                [lastCycleId] : {
                  ...state.portfolios[customerId].self.cycles[lastCycleId],
                  techData: {
                    ...state.portfolios[customerId].self.cycles[lastCycleId].techData,
                    totals: {
                      ...state.portfolios[customerId].self.cycles[lastCycleId].techData.totals,
                      vectors: vectorArray
                    }

                  }
                }
              }
            }
          }
        },

        // loadingUpdateTag: {
        //   ...state.loadingUpdateTag,
        //   [tagId] : false,
        // },
        // loadingUpdateTagError: {
        //   ...state.loadingUpdateTagError,
        //   [tagId] : false,
        // },
      }
    }

    case UPDATE_TAG_FAIL_TESTED_VECTORS: {
      // const tagId = action.payload.tagId
      return {
        ...state,
        // loadingUpdateTag: {
        //   ...state.loadingUpdateTag,
        //   [tagId] : false,
        // },
        // loadingUpdateTagError: {
        //   ...state.loadingUpdateTagError,
        //   [tagId] : true,
        // },
      }
    }

      /***********************************
       * CLOUD_INTEGRATION_GET_OPTIONS
       ***********************************/

    case CLOUD_INTEGRATION_GET_OPTIONS: {
      const entityId = action.payload.entityId
      return {
        ...state,
        loadingCloudIntegrations: {
          ...state.loadingCloudIntegrations,
          [entityId] : true,
        },
        loadingCloudIntegrationsError: {
          ...state.loadingCloudIntegrationsError,
          [entityId] : false,
        },
      }
    }

    case CLOUD_INTEGRATION_GET_OPTIONS_SUCCESS: {

      const entityId = action.payload.entityId
      const newCloudIntegrationData = action.payload.inboundData

      console.log("CLOUD_INTEGRATION_GET_OPTIONS_SUCCESS reducer about to put new business shares into the state. Here are the shares", newCloudIntegrationData, "for this entityId", entityId);

      return {
        ...state,
        cloudIntegrations: {
          ...state.cloudIntegrations,
          [entityId]: newCloudIntegrationData

        },

        loadingCloudIntegrations: {
          ...state.loadingCloudIntegrations,
          [entityId] : false,
        },
        loadingCloudIntegrationsError: {
          ...state.loadingCloudIntegrationsError,
          [entityId] : false,
        },
      }
    }

    case CLOUD_INTEGRATION_GET_OPTIONS_FAIL: {
      const entityId = action.payload.entityId
      return {
        ...state,
        loadingCloudIntegrations: {
          ...state.loadingCloudIntegrations,
          [entityId] : false,
        },
        loadingCloudIntegrationsError: {
          ...state.loadingCloudIntegrationsError,
          [entityId] : true,
        },
      }
    }

      /***********************************
       * CLOUD_INTEGRATION_REGISTER
       ***********************************/

    case CLOUD_INTEGRATION_REGISTER: {
      const entityId = action.payload.entityId
      return {
        ...state,
        loadingCloudIntegrationRegistration: {
          ...state.loadingCloudIntegrationRegistration,
          [entityId] : true,
        },
        loadingCloudIntegrationRegistrationError: {
          ...state.loadingCloudIntegrationRegistrationError,
          [entityId] : false,
        },
      }
    }

    case CLOUD_INTEGRATION_REGISTER_SUCCESS: {

      const redirectURL = action.payload.inboundData.redirect_url
      const newCloudIntegrationData = action.payload.inboundData.integration
      const entityId = newCloudIntegrationData.entity

      console.log("CLOUD_INTEGRATION_REGISTER_SUCCESS reducer about to put new into the state. Here are the data", newCloudIntegrationData, "for this entityId", entityId, "redirectURL will be", redirectURL);

      return {
        ...state,
        cloudIntegrations: {
          ...state.cloudIntegrations,
          [entityId]: {
            ...state.cloudIntegrations[entityId],
            integrations: {
              ...state.cloudIntegrations[entityId].integrations,
              [newCloudIntegrationData.id]: newCloudIntegrationData
            },
            integrationData: null,
          }
        },
        // cloudIntegrationRedirectUrls: {
        //   ...state.cloudIntegrationRedirectUrls,
        //   [entityId]: redirectURL
        // },

        loadingCloudIntegrationRegistration: {
          ...state.loadingCloudIntegrationRegistration,
          [entityId] : false,
        },
        loadingCloudIntegrationRegistrationError: {
          ...state.loadingCloudIntegrationRegistrationError,
          [entityId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustRegisterCloudIntegration: true,
        }
      }
    }

    case CLOUD_INTEGRATION_REGISTER_FAIL: {
      const entityId = action.payload.entityId
      return {
        ...state,
        loadingCloudIntegrationRegistration: {
          ...state.loadingCloudIntegrationRegistration,
          [entityId] : false,
        },
        loadingCloudIntegrationRegistrationError: {
          ...state.loadingCloudIntegrationRegistrationError,
          [entityId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustRegisterCloudIntegration: false,
        }
      }
    }

      /***********************************
       * CLOUD_INTEGRATION_UNREGISTER
       ***********************************/

    case CLOUD_INTEGRATION_UNREGISTER: {
      const integrationId = action.payload.integrationId
      return {
        ...state,
        loadingCloudIntegrationUnregistration: {
          ...state.loadingCloudIntegrationUnregistration,
          [integrationId] : true,
        },
        loadingCloudIntegrationUnregistrationError: {
          ...state.loadingCloudIntegrationUnregistrationError,
          [integrationId] : false,
        },
      }
    }

    case CLOUD_INTEGRATION_UNREGISTER_SUCCESS: {

      const integrationId = action.payload.integrationId
      const newCloudIntegrationData = action.payload.inboundData
      const entityId = newCloudIntegrationData.entity

      console.log("CLOUD_INTEGRATION_UNREGISTER_SUCCESS reducer about to put new into the state. Here are the data", newCloudIntegrationData, "for this integrationId", integrationId);

      return {
        ...state,
        cloudIntegrations: {
          ...state.cloudIntegrations,
          [entityId]: {
            ...state.cloudIntegrations[entityId],
            integrations: {
              ...state.cloudIntegrations[entityId].integrations,
              [newCloudIntegrationData.id]: newCloudIntegrationData
            },
            integrationData: null,
          }
        },

        loadingCloudIntegrationUnregistration: {
          ...state.loadingCloudIntegrationUnregistration,
          [integrationId] : false,
        },
        loadingCloudIntegrationUnregistrationError: {
          ...state.loadingCloudIntegrationUnregistrationError,
          [integrationId] : false,
        },
        appMisc: {
          ...state.appMisc,
          didJustUnregisterCloudIntegration: true,
        }
      }
    }

    case CLOUD_INTEGRATION_UNREGISTER_FAIL: {
      const integrationId = action.payload.integrationId
      return {
        ...state,
        loadingCloudIntegrationUnregistration: {
          ...state.loadingCloudIntegrationUnregistration,
          [integrationId] : false,
        },
        loadingCloudIntegrationUnregistrationError: {
          ...state.loadingCloudIntegrationUnregistrationError,
          [integrationId] : true,
        },
        appMisc: {
          ...state.appMisc,
          didJustUnregisterCloudIntegration: false,
        }
      }
    }

      /***********************************
       * FETCH_CLOUD_INTEGRATION_DATA
       ***********************************/

    case FETCH_CLOUD_INTEGRATION_DATA:{

      const entityId = action.payload.entityId
      const integrationId = action.payload.integrationId
      const queryType = action.payload.queryType

      return{
        ...state,
        loadingCloudIntegrationData:{
          ...state.loadingCloudIntegrationData,
            [entityId]: {
              ...state.loadingCloudIntegrationData[entityId],
              [queryType]: true,
            }
        },
        loadingCloudIntegrationDataError:{
          ...state.loadingCloudIntegrationDataError,
          [entityId]: {
            ...state.loadingCloudIntegrationDataError[entityId],
            [queryType]: false,
          }
        }
      }
    }

    case FETCH_CLOUD_INTEGRATION_DATA_SUCCESS: {
      const entityId = action.payload.entityId
      const integrationId = action.payload.integrationId
      const queryType = action.payload.queryType
      const integrationDescription = action.payload.integrationDescription;
      const inboundData = action.payload.inboundData
      const retrievedDataArray = inboundData
        && inboundData[queryType]
        && Array.isArray(inboundData[queryType])
            ? inboundData[queryType]
            : [];
      const errorMessage = inboundData && (inboundData.error || inboundData.integration_error) ? true : false;
      const userMessage = errorMessage && inboundData && inboundData.userMessage ? inboundData.userMessage : null;

      if(retrievedDataArray && (retrievedDataArray.length > 0)){
        retrievedDataArray.forEach((storageObj)=>{
          storageObj.integrationId = integrationId;
          storageObj.integrationDescription = integrationDescription;
        });
      }

      const existingDataArray = state
          && state.cloudIntegrations
          && state.cloudIntegrations[entityId]
          && state.cloudIntegrations[entityId].integrationData
          && state.cloudIntegrations[entityId].integrationData[queryType]
            ? state.cloudIntegrations[entityId].integrationData[queryType]
            : [];

      const updatedDataArray = existingDataArray.concat(retrievedDataArray);



      try {
        if (!errorMessage) {
          console.log("FETCH_CLOUD_INTEGRATION_DATA_SUCCESS reducer about to put new into the state. Here are the data", retrievedDataArray, "for this integrationId", integrationId);

          return {
            ...state,
            loadingCloudIntegrationData: {
              ...state.loadingCloudIntegrationData,
              [entityId]: {
                ...state.loadingCloudIntegrationData[entityId],
                // [integrationId]: {
                //   ...state.loadingCloudIntegrationData[entityId][integrationId],
                  [queryType]: false
                // }
              }
            },
            loadingCloudIntegrationDataError: {
              ...state.loadingCloudIntegrationDataError,
              [entityId]: {
                ...state.loadingCloudIntegrationDataError[entityId],
                // [integrationId]: {
                //   ...state.loadingCloudIntegrationDataError[entityId][integrationId],
                  [queryType]: false
                // }
              }
            },
            cloudIntegrations: {
              ...state.cloudIntegrations,
              [entityId]: {
                ...state.cloudIntegrations[entityId],
                integrationData: {
                  ...state.cloudIntegrations[entityId].integrationData,
                  [queryType]: updatedDataArray,
                }
                // integrations: {
                //   ...state.cloudIntegrations[entityId].integrations,
                //   [integrationId]: {
                //     ...state.cloudIntegrations[entityId].integrations[integrationId],
                //     integrationData: {
                //       ...state.cloudIntegrations[entityId].integrations[integrationId].integrationData
                //     }
                //   }
                // }
              }
            }
          }
        }else{
          console.log("FETCH_CLOUD_INTEGRATION_DATA_SUCCESS reducer about to put new into the state. Here are the data", retrievedDataArray, "for this integrationId", integrationId, "but there's an error message in the returned api data", errorMessage, "and it says", userMessage );

          return{
            ...state,
            loadingCloudIntegrationData: {
              ...state.loadingCloudIntegrationData,
              [entityId]: {
                ...state.loadingCloudIntegrationData[entityId],
                // [integrationId]: {
                //   ...state.loadingCloudIntegrationData[entityId][integrationId],
                  [queryType]: false
                // }
              }
            },
            loadingCloudIntegrationDataError: {
              ...state.loadingCloudIntegrationDataError,
              [entityId]: {
                ...state.loadingCloudIntegrationDataError[entityId],
                // [integrationId]: {
                //   ...state.loadingCloudIntegrationDataError[entityId][integrationId],
                  [queryType]: true,
                  [`${queryType}_error`]: userMessage,
                // }
              }
            },
            cloudIntegrations: {
              ...state.cloudIntegrations,
              [entityId]: {
                ...state.cloudIntegrations[entityId],
                integrationData: {
                  ...state.cloudIntegrations[entityId].integrationData,
                  [queryType]: updatedDataArray,
                }
                // integrations: {
                //   ...state.cloudIntegrations[entityId].integrations,
                //   [integrationId]: {
                //     ...state.cloudIntegrations[entityId].integrations[integrationId],
                //     integrationData: {
                //       ...state.cloudIntegrations[entityId].integrations[integrationId].integrationData
                //     }
                //   }
                // }
              }
            }
          }
        }
      } catch (e) {
        console.warn("Error uploading integration data for entity: ", entityId, "for integration", integrationId, "of query type:", queryType)
        return{
          ...state,
          loadingCloudIntegrationData:{
            ...state.loadingCloudIntegrationData,
            [entityId]: {
              ...state.loadingCloudIntegrationData[entityId],
              [queryType]: false
            }
            // [entityId]:false,
          },
          loadingCloudIntegrationDataError:{
            ...state.loadingCloudIntegrationDataError,
            [entityId]: {
              ...state.loadingCloudIntegrationDataError[entityId],
              [queryType]: true
              }
            // [entityId]:true,
          },
        }
      }
    }


    case FETCH_CLOUD_INTEGRATION_DATA_FAIL:{
      const entityId = action.payload.entityId
      const integrationId = action.payload.integrationId
      const queryType = action.payload.queryType

      const existingDataArray = state
      && state.cloudIntegrations
      && state.cloudIntegrations[entityId]
      && state.cloudIntegrations[entityId].integrationData
      && state.cloudIntegrations[entityId].integrationData[queryType]
          ? state.cloudIntegrations[entityId].integrationData[queryType]
          : [];

      const requestData = action.payload.request
      const retrievedArray = requestData && requestData[queryType] ? requestData[queryType] : [];
      const updatedArray = existingDataArray.concat(retrievedArray)
      console.log("FETCH_CLOUD_INTEGRATION_DATA_FAIL reducer about to put new into the state. Here is the responde data",requestData, "for this integrationId", integrationId, "for the query TYpe,", queryType );

      return{
        ...state,
        loadingCloudIntegrationData:{
          ...state.loadingCloudIntegrationData,
          [entityId]:{
            ...state.loadingCloudIntegrationData[entityId],
            // [integrationId]:{
            //   ...state.loadingCloudIntegrationData[entityId][integrationId],
              [queryType]: false
            // }
          }
        },
        loadingCloudIntegrationDataError:{
          ...state.loadingCloudIntegrationDataError,
          [entityId]:{
            ...state.loadingCloudIntegrationDataError[entityId],
            // [integrationId]:{
            //   ...state.loadingCloudIntegrationDataError[entityId][integrationId],
              [queryType]: true
            // }
          }
        },
        cloudIntegrations: {
          ...state.cloudIntegrations,
          [entityId]: {
            ...state.cloudIntegrations[entityId],
            integrationData: {
              ...state.cloudIntegrations[entityId].integrationData,
              [queryType]: updatedArray,
            }
          }
        }

      }
    }
      // return {
      //   ...state,
      //   cloudIntegrations: {
      //     ...state.cloudIntegrations,
      //     [entityId]: {
      //       ...state.cloudIntegrations[entityId],
      //       integrations: {
      //         ...state.cloudIntegrations[entityId].integrations,
      //         [newCloudIntegrationData.id]: newCloudIntegrationData
      //       }
      //     }
      //   },

      /***********************************
       * FETCH_CLOUD_INTEGRATION_FILES
       ***********************************/

    case FETCH_CLOUD_INTEGRATION_FILES:{

      const entityId = action.payload.entityId
      const integrationId = action.payload.integrationId
      const storageName =action.payload.storageName

      return{
        ...state,
        loadingCloudIntegrationData:{
          ...state.loadingCloudIntegrationData,
          [entityId]: {
            ...state.loadingCloudIntegrationData[entityId],
            files: true,
          }
        },
        loadingCloudIntegrationDataError:{
          ...state.loadingCloudIntegrationDataError,
          [entityId]: {
            ...state.loadingCloudIntegrationDataError[entityId],
            files: {
              ...state.loadingCloudIntegrationDataError[entityId].files,
              [`${integrationId}-${storageName}`]: {
                hasError: false,
                userMessage: null,
              }
            }
          }
        }
      }
    }

    case FETCH_CLOUD_INTEGRATION_FILES_SUCCESS: {
      const entityId = action.payload.entityId
      const integrationId = action.payload.integrationId
      const storageName =action.payload.storageName
      const inboundData = action.payload.inboundData
      const retrievedFilesObject = inboundData ? inboundData.files : null;
      const retrievedFilesArray = retrievedFilesObject && retrievedFilesObject.files ? retrievedFilesObject.files : [];
      const errorMessage = inboundData && (inboundData.error || inboundData.integration_error) ? true : false;

      const existingFilesArray = state
      && state.cloudIntegrations
      && state.cloudIntegrations[entityId]
      && state.cloudIntegrations[entityId].integrationData
      && state.cloudIntegrations[entityId].integrationData.files
          ? state.cloudIntegrations[entityId].integrationData.files
          : [];


      // const storageObjToAddFilesTo = existingStorageArray && existingStorageArray.find(x => x.name === storageName) ? existingStorageArray.find(x => x.name === storageName) : null;

      // const updatedStorageObj = storageObjToAddFilesTo && retrievedFilesArray ? storageObjToAddFilesTo.files = retrievedFilesArray : storageObjToAddFilesTo.files = null;

      try {
        if (!errorMessage) {
          console.log("FETCH_CLOUD_INTEGRATION_Files_SUCCESS reducer about to put new into the state. Here are the data", inboundData, "for this integrationId", integrationId, "for Storage Item", storageName, "existingFilesArray", existingFilesArray);
          existingFilesArray.push(retrievedFilesObject);

          return {
            ...state,
            loadingCloudIntegrationData: {
              ...state.loadingCloudIntegrationData,
              [entityId]: {
                ...state.loadingCloudIntegrationData[entityId],
                files: false
              }
            },
            loadingCloudIntegrationDataError: {
              ...state.loadingCloudIntegrationDataError,
              [entityId]: {
                ...state.loadingCloudIntegrationDataError[entityId],
                files: {
                  ...state.loadingCloudIntegrationDataError[entityId].files,
                  [`${integrationId}-${storageName}`]: {
                    hasError: false,
                    userMessage: null,
                  }
                }
              }
            },
            cloudIntegrations: {
              ...state.cloudIntegrations,
              [entityId]: {
                ...state.cloudIntegrations[entityId],
                integrationData: {
                  ...state.cloudIntegrations[entityId].integrationData,
                  files: existingFilesArray
                }
              }
            }
          }
        }else{
          console.log("FETCH_CLOUD_INTEGRATION_FILES_SUCCESS reducer about to put new into the state. Here are the data", inboundData, "for this integrationId", integrationId, "for Storage Item", storageName, "updatedStorageObj", existingFilesArray, "errorMessage", errorMessage);

          return{
            ...state,
            loadingCloudIntegrationData: {
              ...state.loadingCloudIntegrationData,
              [entityId]: {
                ...state.loadingCloudIntegrationData[entityId],
                files: false
              }
            },
            loadingCloudIntegrationDataError: {
              ...state.loadingCloudIntegrationDataError,
              [entityId]: {
                ...state.loadingCloudIntegrationDataError[entityId],
                files: {
                  ...state.loadingCloudIntegrationDataError[entityId].files,
                  [`${integrationId}-${storageName}`]: {
                    hasError: true,
                    userMessage: inboundData && inboundData.userMessage ? inboundData.userMessage : "Something Went Wrong",
                  }
                }
              }
            },
            cloudIntegrations: {
              ...state.cloudIntegrations,
              [entityId]: {
                ...state.cloudIntegrations[entityId],
                integrationData: {
                  ...state.cloudIntegrations[entityId].integrationData,
                  files: existingFilesArray,
                }
              }
            }
          }
        }
      } catch (e) {
        console.warn("Error uploading files data for entity: ", entityId, "for integration", inboundData, "for this integrationId", integrationId, "for Storage Item", storageName, "updatedStorageObj", existingFilesArray, "errorMessage", errorMessage);
        return{
          ...state,
          loadingCloudIntegrationData:{
            ...state.loadingCloudIntegrationData,
            [entityId]: {
              ...state.loadingCloudIntegrationData[entityId],
              files: false
            }
          },
          loadingCloudIntegrationDataError:{
            ...state.loadingCloudIntegrationDataError,
            [entityId]: {
              ...state.loadingCloudIntegrationDataError[entityId],
              files: {
                ...state.loadingCloudIntegrationDataError[entityId].files,
                [`${integrationId}-${storageName}`]: {
                  hasError: true,
                  userMessage: inboundData && inboundData.userMessage ? inboundData.userMessage : "Something Went Wrong",
                }
              }
            }
          },
          // cloudIntegrations: {
          //   ...state.cloudIntegrations,
          //   [entityId]: {
          //     ...state.cloudIntegrations[entityId],
          //     integrationData: {
          //       ...state.cloudIntegrations[entityId].integrationData,
          //       files: existingFilesArray,
          //     }
          //   }
          // }
        }
      }
    }


    case FETCH_CLOUD_INTEGRATION_FILES_FAIL:{
      const entityId = action.payload.entityId
      const integrationId = action.payload.integrationId
      const storageName =action.payload.storageName
      const inboundData = action.payload.inboundData
      const retrievedFilesObject = inboundData ? inboundData.files : null;
      const retrievedFilesArray = retrievedFilesObject && retrievedFilesObject.files ? retrievedFilesObject.files : [];
      const errorMessage = inboundData && (inboundData.error || inboundData.integration_error) ? true : false;

      const existingFilesArray = state
      && state.cloudIntegrations
      && state.cloudIntegrations[entityId]
      && state.cloudIntegrations[entityId].integrationData
      && state.cloudIntegrations[entityId].integrationData.files
          ? state.cloudIntegrations[entityId].integrationData.files
          : [];

      // existingFilesArray.push(retrievedFilesObject);

      const requestData = action.payload.request

      console.log("FETCH_CLOUD_INTEGRATION_FILES_FAIL reducer about to put new into the state. Here is the responde data",requestData, "for this integrationId", integrationId,  );

      return{
        ...state,
        loadingCloudIntegrationData:{
          ...state.loadingCloudIntegrationData,
          [entityId]:{
            ...state.loadingCloudIntegrationData[entityId],
            files: false
          }
        },
        loadingCloudIntegrationDataError:{
          ...state.loadingCloudIntegrationDataError,
          [entityId]:{
            ...state.loadingCloudIntegrationDataError[entityId],
            files: {
              ...state.loadingCloudIntegrationDataError[entityId].files,
              [`${integrationId}-${storageName}`]: {
                hasError: true,
                userMessage: inboundData && inboundData.userMessage ? inboundData.userMessage : "Something Went Wrong",
              }
            }
          }
        },
        // cloudIntegrations: {
        //   ...state.cloudIntegrations,
        //   [entityId]: {
        //     ...state.cloudIntegrations[entityId],
        //     integrationData: {
        //       ...state.cloudIntegrations[entityId].integrationData,
        //       files: existingFilesArray,
        //     }
        //   }
        // }

      }
    }


      /***********************************
       * FETCH_CYCLE_SOCIAL
       ***********************************/


    case FETCH_CYCLE_SOCIAL:{

      const cycleId = action.payload.cycleId
      return {
        ...state,
        loadingCycleSocial: {
          ...state.loadingCycleSocial,
          [cycleId] : true,
        },
        loadingCycleSocialError: {
          ...state.loadingCycleSocialError,
          [cycleId] : false,
        },
      }


    }

    case FETCH_CYCLE_SOCIAL_SUCCESS: {

      const pageNumberFetched = action.payload.pageNumberFetched;
      const customerId = action.payload.customerId
      const cycleId = action.payload ? action.payload.cycleId : null;
      const entityId = action.payload ? action.payload.entityId : state.entityInView;

      const newCycleSocialData = action.payload && action.payload.inboundData ? action.payload.inboundData : null;

      // console.log("FETCH_CYCLE_SOCIAL_SUCCESS here's what we got back", action.payload, "also here's state.entityinview", state.entityInView)

      //April 2022 inbound data includes
      // "all_time_totals": {
      //   "tests": 63,
      //       "opens": 11,
      //       "executions": 0,
      //       "success": 0
      // },
      // "cycle_totals": {
      //   "number_identities": 126,
      //       "number_social_tests": 0,
      //       "number_social_tests_opened": 0,
      //       "number_social_tests_action_taken": 0,
      //       "number_social_tests_successful": 0,
      //       "pages": 2,
      //       "page_size": 100
      // },
      // identities": {
      // "db87276b57478b82008cd7b68ad5d6b386ff346e": {
      //   "email": "tjpeterson@allete.com",
      //       "first": null,
      //       "last": null,
      //       "position": null,
      //       "verified": false,
      //       "provided": false
      // },
      // social_tests": {
      //         "24e8e952-caff-409a-bfec-dd0ec93881ef": {
      //             "id": "24e8e952-caff-409a-bfec-dd0ec93881ef",
      //             "tested_identity": {
      //                 "id": "f33d8f21b83661019d22c6c0ccac5d9a990b9e91",
      //                 "email": "iwenzel@allete.com"
      //             },
      //             "template": {
      //                 "id": "103a2abb-a527-4a3e-93e0-a3da6b36ec3c",
      //                 "social_account": {
      //                     "email": "alert@security-notice.org",
      //                     "sender_name": "Cloud Security Alerts"
      //                 },
      //                 "subject": "Your AWS Account Will Soon Be Deleted"
      //             },
      //             "payload": null,
      //             "scheduled_datetime": "2022-02-01T10:10:10",
      //             "sent": true,
      //             "sent_datetime": "2022-03-03T16:20:22",
      //             "opened": false,
      //             "opened_events": [],
      //             "executed": false,
      //             "executed_events": [],
      //             "success": false
      //         },

      const newAllTimeTotals = newCycleSocialData ? newCycleSocialData.all_time_totals : null;
      const newCycleTotals = newCycleSocialData ? newCycleSocialData.cycle_totals : null;
      const newIdentities = newCycleSocialData ? newCycleSocialData.identities : null;
      const newSocialTests = newCycleSocialData ? newCycleSocialData.social_tests : null;

      console.log("cycleID", cycleId, "entityId,", entityId);

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null

      const isSelfSocialData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId
          && customerStateLocation.self.cycles //if this is a self entity
          && cycleId
          && customerStateLocation.self.cycles[cycleId])

      const isBRPSocialData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId]
          && customerStateLocation.entities[entityId].cycles
          && cycleId
          && customerStateLocation.entities[entityId].cycles[cycleId])

      const socialDataStateLocation = isSelfSocialData
          ? customerStateLocation.self.cycles[cycleId].social
              ? customerStateLocation.self.cycles[cycleId].social
              : {}
          : isBRPSocialData
              ? customerStateLocation.entities[entityId].cycles[cycleId].social
                  ? customerStateLocation.entities[entityId].cycles[cycleId].social
                  : {}
              : null

      console.log("FETCH_CYCLE_SOCIAL_SUCCESS", "customerStateLocation", customerStateLocation, "isSelfSocialData", isSelfSocialData, "isBRPTechData", isBRPSocialData, "socialDataStateLocation is", socialDataStateLocation);

      const existingAllTimeTotals = socialDataStateLocation && socialDataStateLocation.allTimeTotals
          ? socialDataStateLocation.allTimeTotals
          : {};
        const existingCycleTotals = socialDataStateLocation && socialDataStateLocation.cycleTotals
            ? socialDataStateLocation.cycleTotals
            : {};
        const existingIdentities = socialDataStateLocation && socialDataStateLocation.identities
            ? socialDataStateLocation.identities
            : {};
        const existingSocialTests = socialDataStateLocation && socialDataStateLocation.socialTests
            ? socialDataStateLocation.socialTests
            : {};


      const lastHighestPageFetched = existingCycleTotals && existingCycleTotals.highestPageFetched ? existingCycleTotals.highestPageFetched : 0;
      const highestPageFetched = lastHighestPageFetched < pageNumberFetched ? pageNumberFetched : lastHighestPageFetched;

      console.log("Lets just check everything- existing totals", existingCycleTotals,"existingAllTimeTotals", existingAllTimeTotals, "existingIdentities",  existingIdentities, "exitingSocialTests,", existingSocialTests, "lastHighestPage", lastHighestPageFetched, "highestPageFetched", highestPageFetched)

        const updatedSocialData= {
          ...socialDataStateLocation,
          allTimeTotals: {
            ...existingAllTimeTotals,
            ...newAllTimeTotals,
          },
          cycleTotals: {
            ...existingCycleTotals,
            ...newCycleTotals,
            highestPageFetched: highestPageFetched,
      },
          identities:{
            ...existingIdentities,
            ...newIdentities,
          },
          socialTests:{
            ...existingSocialTests,
            ...newSocialTests
          }
        }

      console.log("FETCH_CYCLE_SOCIAL_SUCCESS reducer state tree is ", state, "about to insert", updatedSocialData)

      if (isSelfSocialData) {
        return {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                cycles: {
                  ...state.portfolios[customerId].self.cycles,
                  [cycleId]: {
                    ...state.portfolios[customerId].self.cycles[cycleId],
                    social: {
                      ...updatedSocialData
                    }
                  }
                }
              }
            }
          },
          loadingCycleSocial: {
            ...state.loadingCycleSocial,
            [cycleId] : false,
          },
          loadingCycleSocialError: {
            ...state.loadingCycleSocialError,
            [cycleId] : false,
          },
        }
      } else if (isBRPSocialData){
        return{
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                  cycles: {
                    ...state.portfolios[customerId].entities[entityId].cycles,
                    [cycleId]: {
                      ...state.portfolios[customerId].entities[entityId].cycles[cycleId],
                      social: {
                        ...updatedSocialData,
                      }
                    }
                  }
                }
              }
            }
          },
          loadingCycleSocial: {
            ...state.loadingCycleSocial,
            [cycleId] : false,
          },
          loadingCycleSocialError: {
            ...state.loadingCycleSocialError,
            [cycleId] : false,
          },
        };
      } else{
        console.warn("Cannot update state with cycle social details. Error knowing where to put the data");
        return{
          ...state,
          loadingCycleSocial: {
            ...state.loadingCycleSocial,
            [cycleId] : false,
          },
          loadingCycleSocialError: {
            ...state.loadingCycleSocialError,
            [cycleId] : false,
          },

        }
      }

    }

    case FETCH_CYCLE_SOCIAL_FAIL:{
      const cycleId = action.payload.cycleId

      return{
        ...state,
        loadingCycleSocial: {
          ...state.loadingCycleSocial,
          [cycleId] : false,
        },
        loadingCycleSocialError: {
          ...state.loadingCycleSocialError,
          [cycleId] : true,
        },
      }
    }

      /***********************************
       * FETCH_IDENTITY_Details
       ***********************************/

    case FETCH_IDENTITY_DETAILS: {
      const identityId = action.payload.identityId
      return {
        ...state,
        loadingIdentityDetails: {
          ...state.loadingIdentityDetails,
          [identityId] : true,
        },
        loadingIdentityDetailsError: {
          ...state.loadingIdentityDetailsError,
          [identityId] : false,
        },
      }
    }

    case FETCH_IDENTITY_DETAILS_SUCCESS: {

      const identityId = action.payload.identityId;
      const entityId = action.payload.entityId;
      const cycleId = action.payload.cycleId;
      const customerId = action.payload.customerId;


      const newIdentityDetailsData = action.payload && action.payload.inboundData ? action.payload.inboundData : null;
      // const existingIdenities =  state.portfolios[entityId].self.cycles[cycleId].targets


      // console.log("FETCH_IDENTITY_DETAILS_SUCCESS here's what we got back", action.payload,  )

      // console.log("This should be the target ID", targetId, action.payload.targetId)

      // console.log("cycleID", cycleId, "entityId,", entityId, "identityId", identityId);

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null

      const isSelfSocialData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId
          && customerStateLocation.self.cycles //if this is a self entity
          && cycleId
          && customerStateLocation.self.cycles[cycleId])

      const isBRPSocialData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId]
          && customerStateLocation.entities[entityId].cycles
          && cycleId
          && customerStateLocation.entities[entityId].cycles[cycleId])

      const socialDataStateLocation = isSelfSocialData
          ? customerStateLocation.self.cycles[cycleId]
              ? customerStateLocation.self.cycles[cycleId].social.identities
              : {}
          : isBRPSocialData
              ? customerStateLocation.entities[entityId].cycles[cycleId]
                  ? customerStateLocation.entities[entityId].cycles[cycleId].social.identities
                  : {}
              : null

      const existingIdentityObj = socialDataStateLocation[identityId];

      const updatedIdentity = {
        ...existingIdentityObj,
        ...newIdentityDetailsData,
      };

      if (isSelfSocialData) {
        return {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                cycles: {
                  ...state.portfolios[customerId].self.cycles,
                  [cycleId]: {
                    ...state.portfolios[customerId].self.cycles[cycleId],
                    social: {
                      ...state.portfolios[customerId].self.cycles[cycleId].social,
                      identities: {
                        ...state.portfolios[customerId].self.cycles[cycleId].social.identities,
                        [identityId]:{
                          ...updatedIdentity,
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          loadingIdentityDetails: {
            ...state.loadingIdentityDetails,
            [identityId] : false,
          },
          loadingIdentityDetailsError: {
            ...state.loadingIdentityDetailsError,
            [identityId] : false,
          },
        }
      } else if (isBRPSocialData){
        return{
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId]: {
                  ...state.portfolios[customerId].entities[entityId],
                  cycles: {
                    ...state.portfolios[customerId].entities[entityId].cycles,
                    [cycleId]: {
                      ...state.portfolios[customerId].entities[entityId].cycles[cycleId],
                      social: {
                        ...state.portfolios[customerId].entities[entityId].cycles[cycleId].social,
                        identities: {
                          ...state.portfolios[customerId].entities[entityId].cycles[cycleId].social.identities,
                          [identityId]: {
                            ...updatedIdentity,
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          loadingIdentityDetails: {
            ...state.loadingIdentityDetails,
            [identityId] : false,
          },
          loadingIdentityDetailsError: {
            ...state.loadingIdentityDetailsError,
            [identityId] : false,
          },
        };
      } else{
        console.warn("Cannot update state with cycle social details. Error knowing where to put the data");
        return{
          ...state,
          loadingIdentityDetails: {
            ...state.loadingIdentityDetails,
            [cycleId] : false,
          },
          loadingIdentityDetailsError: {
            ...state.loadingIdentityDetailsError,
            [cycleId] : false,
          },

        }
      }

    }

    case FETCH_IDENTITY_DETAILS_FAIL: {
      console.log("fetch identity details fail")
      const identityId = action.payload.identityId;
      return {
        ...state,
        loadingIdentityDetails: {
          ...state.loadingIdentityDetails,
          [identityId] : false,
        },
        loadingIdentityDetailsError: {
          ...state.loadingIdentityDetailsError,
          [identityId] : false,
        },
      }
    }

      /***********************************
       * UPDATE_BR_SOCIAL_TESTS_AUTHORIZED
       ***********************************/

    case UPDATE_BR_SOCIAL_TESTS_AUTHORIZED: {
      const entityId = action.payload.entityId
      return {
        ...state,
        loadingUpdateBRSocialTestsAuthorized: {
          ...state.loadingUpdateBRSocialTestsAuthorized,
          [entityId] : true,
        },
        loadingUpdateBRSocialTestsAuthorizedError: {
          ...state.loadingUpdateBRSocialTestsAuthorizedError,
          [entityId] : false,
        },
      }
    }

    case UPDATE_BR_SOCIAL_TESTS_AUTHORIZED_SUCCESS: {

      // const entities = state.portfolios[action.payload.customerId].entities
      const entityId = action.payload.inboundData.entity
      const customerId = action.payload.customerId
      // const entityId = action.payload.entityId
      const newBRAttacksAuthorizedData = action.payload.inboundData

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null
      const isSelfData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      console.log("UPDATE_BR_SOCIAL_TESTS_AUTHORIZED_SUCCESS here is the inboundData", action.payload.inboundData)

      if(isSelfData){
        return {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                settings: newBRAttacksAuthorizedData
              }
            }
          },

          loadingUpdateBRSocialTestsAuthorized: {
            ...state.loadingUpdateBRSocialTestsAuthorized,
            [entityId] : false,
          },
          loadingUpdateBRSocialTestsAuthorizedError: {
            ...state.loadingUpdateBRSocialTestsAuthorizedError,
            [entityId] : false,
          },
        }
      }else if(isBRPData){

        return{
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId]: {
                  ...state.portfolios[customerId].entities[entityId],
                  settings: newBRAttacksAuthorizedData
                }
              }
            }
          },
          loadingUpdateBRSocialTestsAuthorized: {
            ...state.loadingUpdateBRSocialTestsAuthorized,
            [entityId] : false,
          },
          loadingUpdateBRSocialTestsAuthorizedError: {
            ...state.loadingUpdateBRSocialTestsAuthorizedError,
            [entityId] : false,
          },
        }

      }else{
        return {
          loadingUpdateBRSocialTestsAuthorized: {
            ...state.loadingUpdateBRSocialTestsAuthorized,
            [entityId] : false,
          },
          loadingUpdateBRSocialTestsAuthorizedError: {
            ...state.loadingUpdateBRSocialTestsAuthorizedError,
            [entityId] : false,
          },
      }
      }

    }

    case UPDATE_BR_SOCIAL_TESTS_AUTHORIZED_FAIL: {
      const entityId = action.payload.entityId
      return {
        ...state,
        loadingUpdateBRSocialTestsAuthorized: {
          ...state.loadingUpdateBRSocialTestsAuthorized,
          [entityId] : false,
        },
        loadingUpdateBRSocialTestsAuthorizedError: {
          ...state.loadingUpdateBRSocialTestsAuthorizedError,
          [entityId] : true,
        },
      }
    }

    case ADD_TAG_IDENTITY_SUCCESS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      const customerId = action.payload.customerId
      const identityId = action.payload.affectedElementId
      // const entityId = action.payload.entityId
      const newTagData = action.payload.inboundData
      const lastCycleId = state.portfolios[customerId].self.last_cycle.cycle

      console.log("Adding a new successful Tag to Local State tree.",customerId, identityId, newTagData, lastCycleId);

      return {
        ...state,
        portfolios: {
          ...state.portfolios,
          [customerId] : {
            ...state.portfolios[customerId],
            self: {
              ...state.portfolios[customerId].self,
              cycles : {
                ...state.portfolios[customerId].self.cycles,
                [lastCycleId] : {
                  ...state.portfolios[customerId].self.cycles[lastCycleId],
                  social: {
                    ...state.portfolios[customerId].self.cycles[lastCycleId].social,
                    identities: {
                      ...state.portfolios[customerId].self.cycles[lastCycleId].social.identities,
                      [identityId]: {
                        ...state.portfolios[customerId].self.cycles[lastCycleId].social.identities[identityId],
                        tags: {
                          ...state.portfolios[customerId].self.cycles[lastCycleId].social.identities[identityId].tags,
                          [newTagData.id]:{
                            ...newTagData
                          }
                        }
                      }
                    }

                  }
                }
              }
            }
          }
        },
      }
    }

    case ADD_TAG_IDENTITY_FAIL: {
      // const identityId = action.payload.identityId
      return {
        ...state,
      }
    }

    case UPDATE_TAG_IDENTITY_SUCCESS: {

      //result will be a new record to add to the state
      //also, since was a success, need to set the app misc variable so the form knows to reset

      const customerId = action.payload.customerId
      const identityId = action.payload.affectedElementId
      // const entityId = action.payload.entityId
      // const tagId = action.payload.tagId
      const newTagData = action.payload.inboundData
      const lastCycleId = state.portfolios[customerId].self.last_cycle.cycle

      console.log("UPDATE_TAG_SUCCESS Updateing a new successful Tag to Local State tree.",customerId, identityId, newTagData, lastCycleId);

      return {
        ...state,
        portfolios: {
          ...state.portfolios,
          [customerId] : {
            ...state.portfolios[customerId],
            self: {
              ...state.portfolios[customerId].self,
              cycles : {
                ...state.portfolios[customerId].self.cycles,
                [lastCycleId] : {
                  ...state.portfolios[customerId].self.cycles[lastCycleId],
                  social: {
                    ...state.portfolios[customerId].self.cycles[lastCycleId].social,
                    identities: {
                      ...state.portfolios[customerId].self.cycles[lastCycleId].social.identities,
                      [identityId]: {
                        ...state.portfolios[customerId].self.cycles[lastCycleId].social.identities[identityId],
                        tags: {
                          ...state.portfolios[customerId].self.cycles[lastCycleId].social.identities[identityId].tags,
                          [newTagData.id]:{
                            ...newTagData
                          }
                        }
                      }
                    }

                  }
                }
              }
            }
          }
        },
      }
    }

    case UPDATE_TAG_IDENTITY_FAIL: {
      // const tagId = action.payload.tagId
      return {
        ...state,
      }
    }

    case ADD_TAG_ENTITY_SUCCESS: {
      const customerId = action.payload.customerId;
      const entityId = action.payload.affectedElementId;

      const newTagData = action.payload.inboundData;

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
        ? state.portfolios[customerId]
          : null;

      const isSelfProvidedTag = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isNotSelfEntityTag = !!(customerStateLocation
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      console.log("addNewEntityTagSuccess about to return state, values are: customerId", customerId, "entityID", entityId, "customerStateLocation", customerStateLocation, "isSelfEntity", isSelfProvidedTag, "isNotSelf", isNotSelfEntityTag);

      //tags are an array
      const tagsArray = isSelfProvidedTag
        ? customerStateLocation.self.tags
          ? customerStateLocation.self.tags
              : []
          : isNotSelfEntityTag
      ? customerStateLocation.entities[entityId].tags
              ? customerStateLocation.entities[entityId].tags
              : []
      :null

      tagsArray.push(newTagData)

      if(isSelfProvidedTag){
        const newSelfEntityTagsData= {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                tags: tagsArray,
              }
            }
          },
          appMisc : {
            ...state.appMisc,
            didJustAddEntityTag: {
              ...state.appMisc.didJustAddEntityTag,
              [customerId]: true,
            }
          }
        }
        console.log("New state for addEntityTag--self is", newSelfEntityTagsData)
        return newSelfEntityTagsData
      }else if (isNotSelfEntityTag){
        const newNotSelfEntityTagsData= {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId]: {
                  ...state.portfolios[customerId].entities[entityId],
                  tags: tagsArray,
                }
              }
            }
          },
          appMisc : {
            ...state.appMisc,
            didJustAddEntityTag: {
              ...state.appMisc.didJustAddEntityTag,
              [customerId]: true,
            }
          }
        }
        console.log("New state for addEntityTag--notself is", newNotSelfEntityTagsData)
        return newNotSelfEntityTagsData
      }else{
        console.warn("Cannot update state with entity tag details. Error knowing where to put the data");
        return{
          ...state,
        }
      }
    }

    case ADD_TAG_ENTITY_FAIL: {
      const customerId = action.payload.customerId;
      const entityId = action.payload.affectedElementId;
      console.log("addNewEntityTagFail about to return state, values are: customerId", customerId, "entityID", entityId);

      return{
        ...state,
        appMisc : {
          ...state.appMisc,
          didJustAddEntityTag: {
            ...state.appMisc.didJustAddEntityTag,
            [customerId]: false,
          }
        }
      }
    }

    case UPDATE_TAG_ENTITY_SUCCESS: {

      const customerId = action.payload.customerId;
      const entityId = action.payload.affectedElementId;

      const newTagData = action.payload.inboundData;

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null;

      const isSelfProvidedTag = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isNotSelfEntityTag = !!(customerStateLocation
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])

      //tags are an array
      const tagsArray = isSelfProvidedTag
          ? customerStateLocation.self.tags
              ? customerStateLocation.self.tags
              : []
          : isNotSelfEntityTag
              ? customerStateLocation.entities[entityId].tags
                  ? customerStateLocation.entities[entityId].tags
                  : []
              :null

      const updateTagsArray = tagsArray.filter((tag)=> tag.id !== newTagData.id);

      console.log("updateEntityTagSuccess about to return state, values are: customerId", customerId, "entityID", entityId, "customerStateLocation", customerStateLocation, "isSelfEntity", isSelfProvidedTag, "isNotSelf", isNotSelfEntityTag);

      if(isSelfProvidedTag){
        const newSelfEntityTagsData= {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                tags: updateTagsArray,
              }
            }
          }
        }
        console.log("New state for updateEntityTag--self is", newSelfEntityTagsData)
      }else if (isNotSelfEntityTag){
        const newNotSelfEntityTagsData= {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId]: {
                  ...state.portfolios[customerId].entities[entityId],
                  tags: updateTagsArray,
                }
              }
            }
          }
        }
        console.log("New state for updateEntityTag--notself is", newNotSelfEntityTagsData)
      }else{
        console.warn("Cannot update state with entity tag details. Error knowing where to put the data");
        return{
          ...state,
        }
      }
    }

    case UPDATE_TAG_ENTITY_FAIL:{
      const customerId = action.payload.customerId;
      const entityId = action.payload.affectedElementId;
      console.log("updateEntityTagFail about to return original state, values are: customerId", customerId, "entityID", entityId);

      return{
        ...state,
      }
    }

      /***********************************
       * FETCH VECTOR RESULTS
       ***********************************/

    case FETCH_VECTOR_RESULTS:{
      const entityId = action.payload.entityId;
      const customerId = action.payload.customerId;
      const vectorId = action.payload.vectorId;
      const cycleId = action.payload.cycleId

      return{
        ...state,
        loadingVectorResults: {
          ...state.loadingVectorResults,
          [vectorId]: true,
        },
        loadingVectorResultsError: {
          ...state.loadingVectorResultsError,
          [vectorId]: false,
        },

      }
    }

    case FETCH_VECTOR_RESULTS_SUCCESS:{
      const entityId = action.payload.entityId;
      const customerId = action.payload.customerId;
      const cycleId = action.payload.cycleId
      const vectorId = action.payload.vectorId;

      const newVectorDetails = action.payload.inboundData

      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null

      const isSelfTechData = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId
          && customerStateLocation.self.cycles //if this is a self entity
          && cycleId
          && customerStateLocation.self.cycles[cycleId])

      const isBRPTechData = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId]
          && customerStateLocation.entities[entityId].cycles
          && cycleId
          && customerStateLocation.entities[entityId].cycles[cycleId])

      const techDataStateLocation = isSelfTechData
          ? customerStateLocation.self.cycles[cycleId].techData
              ? customerStateLocation.self.cycles[cycleId].techData
              : {}
          : isBRPTechData
              ? customerStateLocation.entities[entityId].cycles[cycleId].techData
                  ? customerStateLocation.entities[entityId].cycles[cycleId].techData
                  : {}
              : null

      const existingTechDataTotals = techDataStateLocation
        &&techDataStateLocation.totals
          ? techDataStateLocation.totals
            : {}

      const existingVectorsArray = existingTechDataTotals
          && existingTechDataTotals.vectors
            ? existingTechDataTotals.vectors
          : []

      const indexOfExistingVectorsDetails = existingVectorsArray
        && existingVectorsArray.findIndex(x => x.id === vectorId)

      const existingVectorsHaveResults = existingVectorsArray[indexOfExistingVectorsDetails]
          && existingVectorsArray[indexOfExistingVectorsDetails].tested_vector_details
          && existingVectorsArray[indexOfExistingVectorsDetails].tested_vector_details.results
          && Object.keys(existingVectorsArray[indexOfExistingVectorsDetails].tested_vector_details.results).length > 0;

      console.log("FETCH_VECTOR_RESULTS_SUCCESS looking at-- isSelfTechData", isSelfTechData, "isBRPTEch", isBRPTechData, "existingTEchDeataTotals", existingTechDataTotals, "exisitngVectorsArray", existingVectorsArray,"existing vector details does not have results", existingVectorsHaveResults, "updating to", newVectorDetails)

      if(!existingVectorsHaveResults){
        console.log("FETCH_VECTOR_RESULTS, existing vector details has results", existingVectorsHaveResults, "updating to", newVectorDetails)
        existingVectorsArray[indexOfExistingVectorsDetails] = newVectorDetails
      }

      if(isSelfTechData){
        return{
          ...state,
          loadingVectorResults: {
            ...state.loadingVectorResults,
            [vectorId]: false,
          },
          loadingVectorResultsError: {
            ...state.loadingVectorResultsError,
            [vectorId]: false,
          },
          portfolios: {
            ...state.portfolios,
            [customerId] : {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                cycles: {
                    ...state.portfolios[customerId].self.cycles,
                    [cycleId]: {
                      ...state.portfolios[customerId].self.cycles[cycleId],
                      techData: {
                        ...state.portfolios[customerId].self.cycles[cycleId].techData,
                        totals: {
                          ...state.portfolios[customerId].self.cycles[cycleId].techData.totals,
                            vectors: existingVectorsArray,
                        }

                      }
                    }
                  }
                }
              }
          },
        }
        //case for if not self entity
      } else if (isBRPTechData){
        return{
          ...state,
          loadingVectorResults: {
            ...state.loadingVectorResults,
            [vectorId]: false,
          },
          loadingVectorResultsError: {
            ...state.loadingVectorResultsError,
            [vectorId]: false,
          },
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                  cycles: {
                    ...state.portfolios[customerId].entities[entityId].cycles,
                    [cycleId]: {
                      ...state.portfolios[customerId].entities[entityId].cycles[cycleId],
                      techData: {
                        ...state.portfolios[customerId].entities[entityId].cycles[cycleId].techData,
                        totals: {
                          ...state.portfolios[customerId].entities[entityId].cycles[cycleId].techData.totals,
                          vectors: existingVectorsArray,
                        }

                      }
                    }
                  }
                }
              }
            }
          },
        }
      } else{
        console.warn("Cannot update vector with results details. Error knowing where to put the data");
        return{
          ...state,
          loadingVectorResults: {
            ...state.loadingVectorResults,
            [vectorId]: false,
          },
          loadingVectorResultsError: {
            ...state.loadingVectorResultsError,
            [vectorId]: false,
          },
        }
      }

    }

    case FETCH_VECTOR_RESULTS_FAIL:{
      const entityId = action.payload.entityId;
      const customerId = action.payload.customerId;
      const vectorId = action.payload.vectorId;

      return{
        ...state,
        loadingVectorResults: {
          ...state.loadingVectorResults,
          [vectorId]: false,
        },
        loadingVectorResultsError: {
          ...state.loadingVectorResultsError,
          [vectorId]: true,
        },
      }
    }
    case DELETE_BR_ENTITY_FROM_SUBPORTFOLIO_SUCCESS: {
      console.group("DELETE_BR_ENTITY_FROM_SUBPORTFOLIO_SUCCESS reducer HERE'S WHAT WE GOT", action.payload);
      //.details is the entityId
      //payload.affectedElementId is the subportfolioId
      const customerId = action.payload.customerId
      const subportfolioId = action.payload.affectedElementId
      const data = action.payload.inboundData
      const entityId = data && data.details;
      const associatedTagId = action.payload.tagId;
      console.log("customerId", customerId, "subportfolioId", subportfolioId, "data", data, "entityId", entityId, "associatedTagId", associatedTagId);

      //now need to find this customer's subportfolio in the state and remove the element of the .entities array where the entityId is
      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null;

      //copy the target portfolio
      const targetSubportfolioEntityArray = customerStateLocation
        && subportfolioId
        && customerStateLocation.portfolios
          && customerStateLocation.portfolios[subportfolioId]
          ? customerStateLocation.portfolios[subportfolioId].entities
          : null;

      //recreate the new .entities array data
      const newSubportfolioEntitiesArray = associatedTagId && targetSubportfolioEntityArray && Array.isArray(targetSubportfolioEntityArray)
        ? targetSubportfolioEntityArray.filter(entity => entity.id !== associatedTagId)
          : null

      console.log("Got this new newSubportfolioEntitiesArray", newSubportfolioEntitiesArray, "from ", "customerStateLocation", customerStateLocation, "targetSubportfolioEntityArray", targetSubportfolioEntityArray);

      //now, if we've got a good array, then replace the one in the state with this one.
      if(newSubportfolioEntitiesArray){
        return {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              portfolios: {
                ...state.portfolios[customerId].portfolios,
                [subportfolioId]: {
                  ...state.portfolios[customerId].portfolios[subportfolioId],
                  entities: newSubportfolioEntitiesArray
                }
              }
            }
          },
          // loadingCycleSocial: {
          //   ...state.loadingCycleSocial,
          //   [cycleId] : false,
          // },
          // loadingCycleSocialError: {
          //   ...state.loadingCycleSocialError,
          //   [cycleId] : false,
          // },
        }
      } else {
        //something has gone wrong and we won't be able to update the state.
        console.warn("Unable to update local state in DELETE_BR_ENTITY_FROM_SUBPORTFOLIO_SUCCESS", "newSubportfolioEntitiesArray", newSubportfolioEntitiesArray);
        return{
          ...state,
        }
      }

      console.groupEnd();
    }

    case ADD_BR_EXISTING_ENTITY_TO_SUBPORTFOLIO_SUCCESS: {
      console.group("ADD_BR_EXISTING_ENTITY_TO_SUBPORTFOLIO_SUCCESS reducer HERE'S WHAT WE GOT", action.payload);
      //.details is the entityId
      //payload.affectedElementId is the subportfolioId
      const customerId = action.payload.customerId
      const subportfolioId = action.payload.affectedElementId
      const data = action.payload.inboundData
      const entityId = data && data.details;
      const associatedTagId = data && data.id;
      console.log("customerId", customerId, "subportfolioId", subportfolioId, "data", data, "entityId", entityId, "associatedTagId", associatedTagId);

      //now need to find this customer's subportfolio in the state and add the new element of the .entities array
      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null;

      //copy the target portfolio entity array
      const targetSubportfolioEntityArray = customerStateLocation
      && subportfolioId
      && customerStateLocation.portfolios
      && customerStateLocation.portfolios[subportfolioId]
          ? customerStateLocation.portfolios[subportfolioId].entities
          : null;

      //recreate the new .entities array data by adding a new tag in the form of {entity: 123, id: 234}
      const newSubportfolioEntitiesArray = targetSubportfolioEntityArray && Array.isArray(targetSubportfolioEntityArray)
          ? targetSubportfolioEntityArray
          : null

      //push element to the array
      if(newSubportfolioEntitiesArray && Array.isArray(newSubportfolioEntitiesArray)){
        newSubportfolioEntitiesArray.push(
            {
              entity: entityId,
              id: associatedTagId
            }
        )
      }



      console.log("Got this new newSubportfolioEntitiesArray", newSubportfolioEntitiesArray, "from ", "customerStateLocation", customerStateLocation, "targetSubportfolioEntityArray", targetSubportfolioEntityArray);

      //now, if we've got a good array, then replace the one in the state with this one.
      if(newSubportfolioEntitiesArray){
        return {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              portfolios: {
                ...state.portfolios[customerId].portfolios,
                [subportfolioId]: {
                  ...state.portfolios[customerId].portfolios[subportfolioId],
                  entities: newSubportfolioEntitiesArray
                }
              }
            }
          },
          // loadingCycleSocial: {
          //   ...state.loadingCycleSocial,
          //   [cycleId] : false,
          // },
          // loadingCycleSocialError: {
          //   ...state.loadingCycleSocialError,
          //   [cycleId] : false,
          // },
        }
      } else {
        //something has gone wrong and we won't be able to update the state.
        console.warn("Unable to update local state in ADD_BR_EXISTING_ENTITY_TO_SUBPORTFOLIO_SUCCESS", "newSubportfolioEntitiesArray", newSubportfolioEntitiesArray);
        return{
          ...state,
        }
      }

      console.groupEnd();
    }

      /*  jfd**********22.Nov.29.23:09*****
       *   Updating a subportfolio
           ********************** `--===<>==<>==C>-< */
    case UPDATE_BR_SUBPORTFOLIO_SUCCESS: {
      console.group("UPDATE_BR_SUBPORTFOLIO_SUCCESS reducer HERE'S WHAT WE GOT", action.payload);
      //inbound data is a new subportfolio object. just need to push it into the state
      const data = action.payload && action.payload.inboundData;
      const customerId = data.customer
      const updatedSubportfolioId = data.id

      console.log("customerId", customerId, "updatedSubportfolioId", updatedSubportfolioId, "data", data,);

      //now, replace the one in the state with this one.
      if(data){
        return {
          ...state,
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              portfolios: {
                ...state.portfolios[customerId].portfolios,
                [updatedSubportfolioId]: data
              }
            }
          },
          // loadingCycleSocial: {
          //   ...state.loadingCycleSocial,
          //   [cycleId] : false,
          // },
          // loadingCycleSocialError: {
          //   ...state.loadingCycleSocialError,
          //   [cycleId] : false,
          // },
        }
      } else {
        //something has gone wrong and we won't be able to update the state.
        console.warn("Unable to update local state in UPDATE_BR_SUBPORTFOLIO_SUCCESS", "data", data);
        return{
          ...state,
        }
      }

      console.groupEnd();
    }

      /***********************************
       * SET FLAG TO TRIGGER STATE UPDATE FOR ONBOARDING PROGRESS ITEM COMPLETED
       ***********************************/

    // case SET_UPDATE_ENTITY_ONBOARDING_PROGRESS:{
    //   return{
    //     ...state,
    //     updateEntityOnboardingProgress: true,
    //   }
    // }
    //
    // case UNSET_UPDATE_ENTITY_ONBAORDING_PROGRESS:{
    //   return{
    //     ...state,
    //     updateEntityOnboardingProgress: false,
    //   }
    // }

      /***********************************
       * Update name for an entity from within portfolio (removed and then returned)
       ***********************************/

    case UPDATE_ENTITY_NAME: {
      const entityId = action.payload.entityId;
      const customerId = action.payload.customerId;
      const updatedName = action.payload.updatedName;

      return {
        ...state,
        loadingUpdateEntityName: {
          ...state.loadingUpdateEntityName,
          [entityId]: true,
        },
        loadingUpdateEntityNameError: {
          ...state.loadingUpdateEntityNameError,
          [entityId]: false,
        }
      }
    }

    case UPDATE_ENTITY_NAME_SUCCESS : {

      const entityId = action.payload.entityId;
      const customerId = action.payload.customerId;
      const updatedName = action.payload.updatedName;


      const customerStateLocation = state.portfolios
      && customerId
      && state.portfolios[customerId]
          ? state.portfolios[customerId]
          : null

      const isSelfEntity = !!(customerStateLocation
          && customerStateLocation.self
          && customerStateLocation.self.id
          && customerStateLocation.self.id === entityId)

      const isBRPEntity = !!(customerStateLocation //if this is a BRP entity
          && customerStateLocation.entities
          && entityId
          && Object.keys(customerStateLocation.entities).includes(entityId)
          && customerStateLocation.entities[entityId])


      if(isSelfEntity){

        console.log(" UPDATE_ENTITY_NAME_SUCCESS. Data is, isSelfEntity",isSelfEntity ,"customerId", customerId, "entity Id", entityId, "updatedName", updatedName, "inboundData", action.payload.inboundData);

        return {
          ...state,
          loadingUpdateEntityName: {
            ...state.loadingUpdateEntityName,
            [entityId]: false,
          },
          loadingUpdateEntityNameError: {
            ...state.loadingUpdateEntityNameError,
            [entityId]: false,
          },
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              self: {
                ...state.portfolios[customerId].self,
                name: updatedName,
              }
            }
          }
        }
      } else if(isBRPEntity){

        console.log(" UPDATE_ENTITY_NAME_SUCCESS. Data is, isBRPEntity",isBRPEntity ,"customerId", customerId, "entity Id", entityId, "updatedName", updatedName, "inboundData", action.payload.inboundData);

        return {
          ...state,
          loadingUpdateEntityName: {
            ...state.loadingUpdateEntityName,
            [entityId]: true,
          },
          loadingUpdateEntityNameError: {
            ...state.loadingUpdateEntityNameError,
            [entityId]: false,
          },
          portfolios: {
            ...state.portfolios,
            [customerId]: {
              ...state.portfolios[customerId],
              entities: {
                ...state.portfolios[customerId].entities,
                [entityId] : {
                  ...state.portfolios[customerId].entities[entityId],
                  name: updatedName,
                }
              }
            }
          }
        }
      } else{
        console.warn("Could not determine state updates for UPDATE_ENTITY_NAME_SUCCESS. Data is, customerId", customerId, "entity Id", entityId, "updatedName", updatedName, "inboundData", action.payload.inboundData);
        return {
          ...state,
          loadingUpdateEntityName: {
            ...state.loadingUpdateEntityName,
            [entityId]: false,
          },
          loadingUpdateEntityNameError: {
            ...state.loadingUpdateEntityNameError,
            [entityId]: false,
          }
        }
      }
    }

    case UPDATE_ENTITY_NAME_FAIL: {
      const entityId = action.payload.entityId;
      const customerId = action.payload.customerId;
      const updatedName = action.payload.updatedName;

      console.log(" UPDATE_ENTITY_NAME_FAIL. Data is, customerId", customerId, "entity Id", entityId, "updatedName", updatedName, "inboundData", action.payload.inboundData);


      return {
        ...state,
        loadingUpdateEntityName: {
          ...state.loadingUpdateEntityName,
          [entityId]: false,
        },
        loadingUpdateEntityNameError: {
          ...state.loadingUpdateEntityNameError,
          [entityId]: false,
        }
      }
    }




    default:
      return state;
  }
}
